export const AUTHENTICATE_USER = "AUTHENTICATE_USER";
export const AUTHENTICATING_USER_SUCCEEDED = "AUTHENTICATING_USER_SUCCEEDED";
export const AUTHENTICATING_USER_FAILED = "AUTHENTICATING_USER_FAILED";

//Account
export const FETCH_ACCOUNT_REQUEST = "FETCH_ACCOUNT_REQUEST";
export const FETCHING_ACCOUNT_SUCCEDDED = "FETCHING_ACCOUNT_SUCCEDDED";
export const FETCHING_ACCOUNT_FAILED = "FETCHING_ACCOUNT_FAILED";

export const UPDATE_ACCOUNT_REQUEST = "UPDATE_ACCOUNT_REQUEST";
export const UPDATING_ACCOUNT_SUCCEDDED = "UPDATING_ACCOUNT_SUCCEDDED";
export const UPDATING_ACCOUNT_FAILED = "UPDATING_ACCOUNT_FAILED";

//update privacy policy control
export const UPDATING_PRIVACY_POLICY_CONTROL = "UPDATING_PRIVACY_POLICY_CONTROL";
export const UPDATING_PRIVACY_POLICY_CONTROL_SUCCEEDED = "UPDATING_PRIVACY_POLICY_CONTROL_SUCCEEDED";
export const UPDATING_PRIVACY_POLICY_CONTROL_FAILED = "UPDATING_PRIVACY_POLICY_CONTROL_FAILED";

//User
export const FETCH_USER_PROFILE = "FETCHING_USER_PROFILE";
export const FETCHING_USER_PROFILE_SUCCEDDED = "FETCHING_USER_PROFILE_SUCCEDDED";
export const FETCHING_USER_PROFILE_FAILED = "FETCHING_USER_PROFILE_FAILED";

export const UPDATING_USER_PROFILE = "UPDATING_USER_PROFILE";
export const UPDATING_USER_PROFILE_SUCCEDDED = "UPDATING_USER_PROFILE_SUCCEDDED";
export const UPDATING_USER_PROFILE_FAILED = "UPDATING_USER_PROFILE_FAILED";

export const FETCHING_USER_NOTIFICATION_PREFERENCES = "FETCHING_USER_NOTIFICATION_PREFERENCES";
export const FETCHING_USER_NOTIFICATION_PREFERENCES_SUCCEEDED = "FETCHING_USER_NOTIFICATION_PREFERENCES_SUCCEEDED";
export const FETCHING_USER_NOTIFICATION_PREFERENCES_FAILED = "FETCHING_USER_NOTIFICATION_PREFERENCES_FAILED";

export const UPDATING_USER_NOTIFICATION_PREFERENCES = "UPDATING_USER_NOTIFICATION_PREFERENCES";
export const UPDATING_USER_NOTIFICATION_PREFERENCES_SUCCEEDED = "UPDATING_USER_NOTIFICATION_PREFERENCES_SUCCEEDED";
export const UPDATING_USER_NOTIFICATION_PREFERENCES_FAILED = "UPDATING_USER_NOTIFICATION_PREFERENCES_FAILED";

export const INVALIDATE_USER_NOTIFICATION_PREFERENCES_UPDATE = "INVALIDATE_USER_NOTIFICATION_PREFERENCES_UPDATE";

export const CHANGING_PASSWORD = "CHANGE_PASSWORD";
export const CHANGING_PASSWORD_SUCCEEDED = "CHANGING_PASSWORD_SUCCEEDED";
export const CHANGING_PASSWORD_FAILED = "CHANGING_PASSWORD_FAILED";

export const RESET_PASSWORD = "RESET_PASSWORD";
export const RESETTING_PASSWORD_SUCCEEDED = "RESETTING_PASSWORD_SUCCEEDED";
export const RESETTING_PASSWORD_FAILED = "RESETTING_PASSWORD_FAILED";

export const UPDATING_EMAIL_SIGNATURE = "UPDATING_EMAIL_SIGNATURE";
export const UPDATING_EMAIL_SIGNATURE_SUCCEEDED = "UPDATING_EMAIL_SIGNATURE_SUCCEEDED";
export const UPDATING_EMAIL_SIGNATURE_FAILED = "UPDATING_EMAIL_SIGNATURE_FAILED";

export const LOGOUT_USER = "LOGOUT_USER";

export const FETCH_SSO_URL_REQUEST = "FETCHING_SSO_URL_REQUEST";
export const FETCHING_SSO_URL_SUCCEEDED = "FETCHING_SSO_URL_SUCCEEDED";
export const FETCHING_SSO_URL_FAILED = "FETCHING_SSO_URL_FAILED";
export const SSO_AUTHENTICATION_FAILED = "SSO_AUTHENTICATION_FAILED";

export const FORGOT_PASSWORD_REQUEST = "FORGOT_PASSWORD_REQUEST";
export const FORGOT_PASSWORD_SUCCEEDED = "FORGOT_PASSWORD_SUCCEEDED";
export const FORGOT_PASSWORD_FAILED = "FORGOT_PASSWORD_FAILED";
export const INVALIDATE_FORGOT_PASSWORD = "INVALIDATE_FORGOT_PASSWORD";

export const SIGNUP_USER_REQUEST = "SIGNUP_USER_REQUEST";
export const SIGNUP_USER_SUCCEEDED = "SIGNUP_USER_SUCCEEDED";
export const SIGNUP_USER_FAILED = "SIGNUP_USER_FAILED";

export const USER_ACTIVATION_REQUEST = "USER_ACTIVATION_REQUEST";
export const USER_ACTIVATION_SUCCEEDED = "USER_ACTIVATION_SUCCEEDED";
export const USER_ACTIVATION_FAILED = "USER_ACTIVATION_FAILED";

export const VALIDATE_REGISTRATION = "VALIDATE_REGISTRATION";
export const VALIDATING_REGISTRATION_SUCCEEDED = "VALIDATING_REGISTRATION_SUCCEEDED";
export const VALIDATING_REGISTRATION_FAILED = "VALIDATING_REGISTRATION_FAILED";

export const WS_SAMPLE_DATA_STREAM_COMPLETION = "WS_SAMPLE_DATA_STREAM_COMPLETION";

export const VALIDATING_PASSWORD_RESET_LINK = "VALIDATING_PASSWORD_RESET_LINK";
export const VALIDATING_PASSWORD_RESET_LINK_SUCCEEDED = "VALIDATING_PASSWORD_RESET_LINK_SUCCEEDED";
export const VALIDATING_PASSWORD_RESET_LINK_FAILED = "VALIDATING_PASSWORD_RESET_LINK_FAILED";

export const FETCH_USER_INVITATION = "FETCH_USER_INVITATION";
export const FETCHING_USER_INVITATION_SUCCEEDED = "FETCHING_USER_INVITATION_SUCCEEDED";
export const FETCHING_USER_INVITATION_FAILED = "FETCHING_USER_INVITATION_FAILED";

export const REGISTER_INVITED_USER = "REGISTER_INVITED_USER";
export const REGISTERING_INVITED_USER_SUCCEEDED = "REGISTERING_INVITED_USER_SUCCEEDED";
export const REGISTERING_INVITED_USER_FAILED = "REGISTERING_INVITED_USER_FAILED";

//Content Hub
export const FETCHING_HUB_LAYOUT = "FETCHING_HUB_LAYOUT";
export const FETCHING_HUB_LAYOUT_SUCCEEDED = "FETCHING_HUB_LAYOUT_SUCCEEDED";
export const FETCHING_HUB_LAYOUT_FAILED = "FETCHING_HUB_LAYOUT_FAILED";
export const INVALIDATE_HUB_LAYOUT = "INVALIDATE_HUB_LAYOUT";

export const FETCHING_HUB_LAYOUTS = "FETCHING_HUB_LAYOUTS";
export const FETCHING_HUB_LAYOUTS_SUCCEEDED = "FETCHING_HUB_LAYOUTS_SUCCEEDED";
export const FETCHING_HUB_LAYOUTS_FAILED = "FETCHING_HUB_LAYOUTS_FAILED";

export const UPDATING_HUB_LAYOUT = "UPDATING_HUB_LAYOUT";
export const UPDATING_HUB_LAYOUT_SUCCEEDED = "UPDATING_HUB_LAYOUT_SUCCEEDED";
export const UPDATING_HUB_LAYOUT_FAILED = "UPDATING_HUB_LAYOUT_FAILED";

export const DELETING_HUB_LAYOUT = "DELETING_HUB_LAYOUT";
export const DELETING_HUB_LAYOUT_SUCCEEDED = "DELETING_HUB_LAYOUT_SUCCEEDED";
export const DELETING_HUB_LAYOUT_FAILED = "DELETING_HUB_LAYOUT_FAILED";

export const FETCHING_HUB_SECTION = "FETCHING_HUB_SECTION";
export const FETCHING_HUB_SECTION_SUCCEEDED = "FETCHING_HUB_SECTION_SUCCEEDED";
export const FETCHING_HUB_SECTION_FAILED = "FETCHING_HUB_SECTION_FAILED";
export const INVALIDATE_HUB_SECTION = "INVALIDATE_HUB_SECTION";

export const UPDATING_HUB_SECTION = "UPDATING_HUB_SECTION";
export const UPDATING_HUB_SECTION_SUCCEEDED = "UPDATING_HUB_SECTION_SUCCEEDED";
export const UPDATING_HUB_SECTION_FAILED = "UPDATING_HUB_SECTION_FAILED";

export const DELETING_HUB_SECTION = "DELETING_HUB_SECTION";
export const DELETING_HUB_SECTION_SUCCEEDED = "DELETING_HUB_SECTION_SUCCEEDED";
export const DELETING_HUB_SECTION_FAILED = "DELETING_HUB_SECTION_FAILED";

export const REARRANGE_HUB_LAYOUT = "REARRANGE_HUB_LAYOUT";
export const REARRANGING_HUB_LAYOUT_SUCCEEDED = "REARRANGING_HUB_LAYOUT_SUCCEEDED";

export const INVALIDATE_HUB_LAYOUT_UPDATE = "INVALIDATE_HUB_LAYOUT_UPDATE";

export const ENABLING_LAYOUT_ACCESS_FOR_USER_GROUPS = "ENABLING_LAYOUT_ACCESS_FOR_USER_GROUPS";
export const ENABLING_LAYOUT_ACCESS_FOR_USER_GROUPS_SUCCEEDED = "ENABLING_LAYOUT_ACCESS_FOR_USER_GROUPS_SUCCEEDED";
export const ENABLING_LAYOUT_ACCESS_FOR_USER_GROUPS_FAILED = "ENABLING_LAYOUT_ACCESS_FOR_USER_GROUPS_FAILED";

export const FETCHING_ACTIVE_USERS_COUNT = "FETCHING_ACTIVE_USERS_COUNT";
export const FETCHING_ACTIVE_USERS_COUNT_SUCCEEDED = "FETCHING_ACTIVE_USERS_COUNT_SUCCEEDED";
export const FETCHING_ACTIVE_USERS_COUNT_FAILED = "FETCHING_ACTIVE_USERS_COUNT_FAILED";

export const FETCHING_USERS = "FETCHING_USERS";
export const FETCHING_USERS_SUCCEEDED = "FETCHING_USERS_SUCCEEDED";
export const FETCHING_USERS_FAILED = "FETCHING_USERS_FAILED";

//Assets
export const FETCHING_ASSET_REQUEST = "FETCHING_ASSET_REQUEST";
export const FETCHING_ASSET_SUCCEEDED = "FETCHING_ASSET_SUCCEEDED";
export const FETCHING_ASSET_FAILED = "FETCHING_ASSET_FAILED";

export const FETCHING_ASSET_ANALYTICS_REQUEST = "FETCHING_ASSET_ANALYTICS_REQUEST";
export const FETCHING_ASSET_ANALYTICS_SUCCEEDED = "FETCHING_ASSET_ANALYTICS_SUCCEEDED";
export const FETCHING_ASSET_ANALYTICS_FAILED = "FETCHING_ASSET_ANALYTICS_FAILED";

export const UPDATING_ASSET_REQUEST = "UPDATING_ASSET_REQUEST";
export const UPDATING_ASSET_SUCCEEDED = "UPDATING_ASSET_SUCCEEDED";
export const UPDATING_ASSET_FAILED = "UPDATING_ASSET_FAILED";
export const INVALIDATE_ASSET_UPDATE = "INVALIDATE_ASSET_UPDATE";

//Assets Subtitle
export const FETCHING_ASSET_SUBTITLE = "FETCHING_ASSET_SUBTITLE";
export const FETCHING_ASSET_SUBTITLE_SUCCEDDED = "FETCHING_ASSET_SUBTITLE_SUCCEDDED";
export const FETCHING_ASSET_SUBTITLE_FAILED = "FETCHING_ASSET_SUBTITLE_FAILED";

//Updating the Subtitles
export const UPDATING_SUBTITLE = "UPDATING_SUBTITLE";
export const UPDATING_SUBTITLE_SUCCEDDED = "UPDATING_SUBTITLE_SUCCEDDED";
export const UPDATING_SUBTITLE_FAILED = "UPDATING_SUBTITLE_FAILED";
export const INVALIDATE_SUBTITLE_UPDATE = "INVALIDATE_SUBTITLE_UPDATE";

export const FETCHING_PREVIEW_ASSET = "FETCHING_PREVIEW_ASSET";
export const FETCHING_PREVIEW_ASSET_SUCCEEDED = "FETCHING_PREVIEW_ASSET_SUCCEEDED";
export const FETCHING_PREVIEW_ASSET_FAILED = "FETCHING_PREVIEW_ASSET_FAILED";

export const FETCH_ASSET_PREVIEW_TEXT = "FETCH_ASSET_PREVIEW_TEXT";
export const FETCHING_ASSET_PREVIEW_TEXT_SUCCEEDED = "FETCHING_ASSET_PREVIEW_TEXT_SUCCEEDED";
export const FETCHING_ASSET_PREVIEW_TEXT_FAILED = "FETCHING_ASSET_PREVIEW_TEXT_FAILED";

export const RECORD_SESSION_ANALYTICS_EVENT = "RECORD_SESSION_ANALYTICS_EVENT";
export const RECORDING_SESSION_ANALYTICS_EVENT_SUCCEEDED = "RECORDING_SESSION_ANALYTICS_EVENT_SUCCEEDED";
export const RECORDING_SESSION_ANALYTICS_EVENT_FAILED = "RECORDING_SESSION_ANALYTICS_EVENT_FAILED";

export const RECORD_ANALYTICS_EVENT = "RECORD_ANALYTICS_EVENT";
export const RECORDING_ANALYTICS_EVENT_SUCCEEDED = "RECORDING_ANALYTICS_EVENT_SUCCEEDED";
export const RECORDING_ANALYTICS_EVENT_FAILED = "RECORDING_ANALYTICS_EVENT_FAILED";

export const INITIATE_UPLOAD_NEW_VERSION = "INITIATE_UPLOAD_NEW_VERSION";
export const UPLOAD_NEW_VERSION = "UPLOAD_NEW_VERSION";
export const UPLOADING_NEW_VERSION_SUCCEEDED = "UPLOADING_NEW_VERSION_SUCCEEDED";
export const UPLOADING_NEW_VERSION_FAILED = "UPLOADING_NEW_VERSION_FAILED";
export const CANCEL_NEW_VERSION_UPLOAD = "CANCEL_NEW_VERSION_UPLOAD";

export const UPDATE_CLEVERSTORY_ASSET_METADATA_REQUEST = "UPDATE_CLEVERSTORY_ASSET_METADATA_REQUEST";
export const UPDATING_CLEVERSTORY_ASSET_METADATA_SUCCEEDED = "UPDATING_CLEVERSTORY_ASSET_METADATA_SUCCEEDED";
export const UPDATING_CLEVERSTORY_ASSET_METADATA_FAILED = "UPDATING_CLEVERSTORY_ASSET_METADATA_FAILED";

export const FETCH_ASSET_INSIGHTS = "FETCH_ASSET_INSIGHTS";
export const FETCHING_ASSET_INSIGHTS_SUCCEEDED = "FETCHING_ASSET_INSIGHTS_SUCCEEDED";
export const FETCHING_ASSET_INSIGHTS_FAILED = "FETCHING_ASSET_INSIGHTS_FAILED";

//Upload Asset
export const UPLOAD_FILE_REQUEST = "UPLOAD_FILE_REQUEST";
export const UPLOADING_FILE_SUCCEDDED = "UPLOADING_FILE_SUCCEDDED";
export const UPLOADING_FILE_FAILED = "UPLOADING_FILE_FAILED";
export const UPLOADING_FILE_PROGRESS = "UPLOADING_FILE_PROGRESS";
export const CANCELING_UPLOAD_ASSET = "CANCELING_UPLOAD_ASSET";

export const CREATE_ASSET_FROM_FILE_REQUEST = "CREATE_ASSET_FROM_FILE_REQUEST";
export const CREATING_ASSET_FROM_FILE_SUCCEDDED = "CREATING_ASSET_FROM_FILE_SUCCEDDED";
export const CREATING_ASSET_FROM_FILE_FAILED = "CREATING_ASSET_FROM_FILE_FAILED";

export const INVALIDATE_ASSET_UPLOAD = "INVALIDATE_ASSET_UPLOAD";

export const WS_ASSET_PROCESSED = "WS_ASSET_PROCESSED";
export const WS_ASSET_MERGE_STATUS = "WS_ASSET_MERGE_STATUS";

// Background Task
export const START_BACKGROUND_UPLOAD_TASK = "START_BACKGROUND_UPLOAD_TASK";
export const COMPLETE_BACKGROUND_UPLOAD_TASK = "COMPLETE_BACKGROUND_UPLOAD_TASK";
export const CANCEL_BACKGROUND_UPLOAD_TASK = "CANCEL_BACKGROUND_UPLOAD_TASK";
export const INVALIDATE_BACKGROUND_UPLOAD_TASK = "INVALIDATE_BACKGROUND_UPLOAD_TASK";

//clone asset
export const CLONE_ASSET_REQUEST = "CLONE_ASSET_REQUEST";
export const CLONING_ASSET_SUCCEDDED = "CLONING_ASSET_SUCCEDDED";
export const CLONING_ASSET_FAILED = "CLONING_ASSET_FAILED";
export const INVALIDATE_ASSET_CLONE = "INVALIDATE_ASSET_CLONE";

//fetch recommended assets 
export const FETCH_RECOMMENDED_ASSETS = "FETCH_RECOMMENDED_ASSETS";
export const FETCHING_RECOMMENDED_ASSETS_SUCCEDDED = "FETCHING_RECOMMENDED_ASSETS_SUCCEDDED";
export const FETCHING_RECOMMENDED_ASSETS_FAILED = "FETCHING_RECOMMENDED_ASSETS_FAILED";

//invalidate recommended assets
export const INVALIDATE_ASSET_RECOMMENDATIONS = "INVALIDATE_ASSET_RECOMMENDATIONS"

//Trigger the Asset Processing
export const TRIGGER_ASSET_PROCESSING_REQUEST = "TRIGGER_ASSET_PROCESSING_REQUEST";
export const TRIGGER_ASSET_PROCESSING_SUCCEEDED = "TRIGGER_ASSET_PROCESSING_SUCCEEDED";
export const TRIGGER_ASSET_PROCESSING_FAILED = "TRIGGER_ASSET_PROCESSING_FAILED";

//Custom Fields
export const FETCHING_CUSTOM_FIELDS_REQUEST = "FETCHING_CUSTOM_FIELDS_REQUEST";
export const FETCHING_CUSTOM_FIELDS_SUCCEEDED = "FETCHING_CUSTOM_FIELDS_SUCCEEDED";
export const FETCHING_CUSTOM_FIELDS_FAILED = "FETCHING_CUSTOM_FIELDS_FAILED";

export const FETCHING_PREVIEW_HTML_TEMPLATE = "FETCHING_PREVIEW_HTML_TEMPLATE";
export const FETCHING_PREVIEW_HTML_TEMPLATE_SUCCEDDED = "FETCHING_PREVIEW_HTML_TEMPLATE_SUCCEDDED";
export const FETCHING_PREVIEW_HTML_TEMPLATE_FAILED = "FETCHING_PREVIEW_HTML_TEMPLATE_FAILED";

//asset storage limit
export const FETCHING_ASSET_STORAGE_LIMIT = "FETCHING_ASSET_STORAGE_LIMIT";
export const FETCHING_ASSET_STORAGE_LIMIT_SUCCEEDED = "FETCHING_ASSET_STORAGE_LIMIT_SUCCEEDED";
export const FETCHING_ASSET_STORAGE_LIMIT_FAILED = "FETCHING_ASSET_STORAGE_LIMIT_FAILED";

/**
 * Streams
*/
//fetch streams for user
export const FETCHING_STREAMS_REQUEST = "FETCHING_STREAMS_REQUEST";
export const FETCHING_STREAMS_SUCCEEDED = "FETCHING_STREAMS_SUCCEEDED";
export const FETCHING_STREAMS_FAILED = "FETCHING_STREAMS_FAILED";

//fetch single stream
export const FETCHING_STREAM_REQUEST = "FETCHING_STREAM_REQUEST";
export const FETCHING_STREAM_SUCCEEDED = "FETCHING_STREAM_SUCCEEDED";
export const FETCHING_STREAM_FAILED = "FETCHING_STREAM_FAILED";

//fetch stream children
export const FETCHING_STREAM_CHILDREN_REQUEST =
  "FETCHING_STREAM_CHILDREN_REQUEST";
export const FETCHING_STREAM_CHILDREN_SUCCEEDED =
  "FETCHING_STREAM_CHILDREN_SUCCEEDED";
export const FETCHING_STREAM_CHILDREN_FAILED =
  "FETCHING_STREAM_CHILDREN_FAILED";

//fetch stream analytics
export const FETCHING_STREAM_ANALYTICS_REQUEST =
  "FETCHING_STREAM_ANALYTICS_REQUEST";
export const FETCHING_STREAM_ANALYTICS_SUCCEEDED =
  "FETCHING_STREAM_ANALYTICS_SUCCEEDED";
export const FETCHING_STREAM_ANALYTICS_FAILED =
  "FETCHING_STREAM_ANALYTICS_FAILED";

//delete stream
export const DELETING_STREAM_REQUEST = "DELETING_STREAM_REQUEST";
export const DELETING_STREAM_SUCCEEDED = "DELETING_STREAM_SUCCEEDED";
export const DELETING_STREAM_FAILED = "DELETING_STREAM_FAILED";

//update stream
export const UPDATING_STREAM_REQUEST = "UPDATING_STREAM_REQUEST";
export const UPDATING_STREAM_SUCCEEDED = "UPDATING_STREAM_SUCCEEDED";
export const UPDATING_STREAM_FAILED = "UPDATING_STREAM_FAILED";

//fetch user access
export const FETCHING_USER_ACCESS = "FETCHING_USER_ACCESS";
export const FETCING_USER_ACCESS_SUCCEEDED = "FETCING_USER_ACCESS_SUCCEEDED";
export const FETCHING_USER_ACCESS_FAILED = "FETCHING_USER_ACCESS_FAILED";

//fetch stream access users
export const FETCHING_STREAM_ACCESS_USERS = "FETCHING_STREAM_ACCESS_USERS";
export const FETCHING_STREAM_ACCESS_USERS_SUCCEEDED = "FETCHING_STREAM_ACCESS_USERS_SUCCEEDED";
export const FETCHING_STREAM_ACCESS_USERS_FAILED = "FETCHING_STREAM_ACCESS_USERS_FAILED";

//update stream access
export const UPDATING_STREAM_ACCESS = "UPDATING_STREAM_ACCESS";
export const UPDATING_STREAM_ACCESS_SUCCEDDED = "UPDATING_STREAM_ACCESS_SUCCEDDED";
export const UPDATING_STREAM_ACCESS_FAILED = "UPDATING_STREAM_ACCESS_FAILED";

//fetch owner groups
export const FETCHING_OWNER_STREAMS = "FETCHING_OWNER_STREAMS";
export const FETCHING_OWNER_STREAMS_SUCCEEDED = "FETCHING_OWNER_STREAMS_SUCEEDED";
export const FETCHING_OWNER_STREAMS_FAILED = "FETCHING_OWNER_STREAMS_FAILED";

//select stream for access management
export const SELECT_STREAM_FOR_ACCESS_MANAGEMENT = "SELECT_STREAM_FOR_ACCESS_MANAGEMENT";

//invalidate stream access user
export const INVALIDATE_STREAM_ACCESS_USERS = "INVALIDATE_STREAM_ACCESS_USERS";

//update group
export const UPDATING_GROUP_REQUEST = "UPDATING_GROUP_REQUEST";
export const UPDATING_GROUP_SUCCEEDED = "UPDATING_GROUP_SUCCEEDED";
export const UPDATING_GROUP_FAILED = "UPDATING_GROUP_FAILED";

//Collection List
export const CREATE_COLLECTION_LIST_REQUEST = "CREATE_COLLECTION_LIST_REQUEST";
export const CREATING_COLLECTION_LIST_SUCCEEDED =
  "CREATING_COLLECTION_LIST_SUCCEEDED";
export const CREATING_COLLECTION_LIST_FAILED =
  "CREATING_COLLECTION_LIST_FAILED";

export const UPDATE_COLLECTION_LIST_REQUEST = "UPDATE_COLLECTION_LIST_REQUEST";
export const UPDATING_COLLECTION_LIST_SUCCEEDED =
  "UPDATING_COLLECTION_LIST_SUCCEEDED";
export const UPDATING_COLLECTION_LIST_FAILED =
  "UPDATING_COLLECTION_LIST_FAILED";

export const DELETE_COLLECTION_LIST_REQUEST = "DELETE_COLLECTION_LIST_REQUEST";
export const DELETING_COLLECTION_LIST_SUCCEEDED =
  "DELETING_COLLECTION_LIST_SUCCEEDED";
export const DELETING_COLLECTION_LIST_FAILED =
  "DELETING_COLLECTION_LIST_FAILED";

export const FETCH_COLLECTION_LISTS_REQUEST = "FETCH_COLLECTION_LISTS_REQUEST";
export const FETCHING_COLLECTION_LISTS_SUCCEEDED =
  "FETCHING_COLLECTION_LISTS_SUCCEEDED";
export const FETCHING_COLLECTION_LISTS_FAILED =
  "FETCHING_COLLECTION_LISTS_FAILED";

export const ADD_COLLECTION_TO_LIST_REQUEST = "ADD_COLLECTION_TO_LIST_REQUEST";
export const ADDING_COLLECTION_TO_LIST_SUCCEEDED =
  "ADDING_COLLECTION_TO_LIST_SUCCEEDED";
export const ADDING_COLLECTION_TO_LIST_FAILED =
  "ADDING_COLLECTION_TO_LIST_FAILED";

export const REMOVE_COLLECTION_FROM_LIST_REQUEST =
  "REMOVE_COLLECTION_FROM_LIST_REQUEST";
export const REMOVING_COLLECTION_FROM_LIST_SUCCEEDED =
  "REMOVING_COLLECTION_FROM_LIST_SUCCEEDED";
export const REMOVING_COLLECTION_FROM_LIST_FAILED =
  "REMOVING_COLLECTION_FROM_LIST_FAILED";

export const INVALIDATE_COLLECTION_LIST_CREATION_STATE =
  "INVALIDATE_COLLECTION_LIST_CREATION_STATE";
export const INVALIDATE_COLLECTION_LIST_UPDATE_STATE =
  "INVALIDATE_COLLECTION_LIST_UPDATE_STATE";
export const INVALIDATE_COLLECTION_LIST_DELETION_STATE =
  "INVALIDATE_COLLECTION_LIST_DELETION_STATE";

//Collections
export const FETCH_COLLECTIONS_REQUEST = "FETCH_COLLECTIONS_REQUEST";
export const FETCHING_COLLECTIONS_SUCCEEDED = "FETCHING_COLLECTIONS_SUCCEEDED";
export const FETCHING_COLLECTIONS_FAILED = "FETCHING_COLLECTIONS_FAILED";

export const FETCH_ASSETS_FROM_UNCATEGORIZED_COLLECTION = "FETCH_ASSETS_FROM_UNCATEGORIZED_COLLECTION";
export const FETCHING_ASSETS_FROM_UNCATEGORIZED_COLLECTION_SUCCEDDED = "FETCHING_ASSETS_FROM_UNCATEGORIZED_COLLECTION_SUCCEDDED";
export const FETCHING_ASSETS_FROM_UNCATEGORIZED_COLLECTION_FAILED = "FETCHING_ASSETS_FROM_UNCATEGORIZED_COLLECTION_FAILED";
export const INVALIDATE_ASSETS_FROM_UNCATEGORIZED_COLLECTION = "INVALIDATE_ASSETS_FROM_UNCATEGORIZED_COLLECTION";
export const SORT_UNCATEGORIZED_COLLECTION_CHILDREN = "SORT_UNCATEGORIZED_COLLECTION_CHILDREN";

export const DELETE_UNCATEGORIZED_ASSET = "DELETE_UNCATEGORIZED_ASSET";
export const DELETING_UNCATEGORIZED_ASSET_SUCCEEDED = "DELETING_UNCATEGORIZED_ASSET_SUCCEEDED";
export const DELETING_UNCATEGORIZED_ASSET_FAILED = "DELETING_UNCATEGORIZED_ASSET_FAILED";
export const INVALIDATE_UNCATEGORIZED_ASSET_DELETION = "INVALIDATE_UNCATEGORIZED_ASSET_DELETION";

export const INVALIDATE_COLLECTIONS = "INVALIDATE_COLLECTIONS";

//Collection
export const FETCH_COLLECTION_REQUEST = "FETCH_COLLECTION_REQUEST";
export const FETCHING_COLLECTION_SUCCEEDED = "FETCHING_COLLECTION_SUCCEEDED";
export const FETCHING_COLLECTION_FAILED = "FETCHING_COLLECTION_FAILED";

export const UPDATE_COLLECTION_REQUEST = "UPDATE_COLLECTION_REQUEST";
export const UPDATING_COLLECTION_SUCCEEDED = "UPDATING_COLLECTION_SUCCEEDED";
export const UPDATING_COLLECTION_FAILED = "UPDATING_COLLECTION_FAILED";

export const CREATE_COLLECTION_REQUEST = "CREATE_COLLECTION_REQUEST";
export const CREATING_COLLECTION_SUCCEEDED = "CREATING_COLLECTION_SUCCEEDED";
export const CREATING_COLLECTION_FAILED = "CREATING_COLLECTION_FAILED";

export const DELETE_COLLECTION_REQUEST = "DELETE_COLLECTION_REQUEST";
export const DELETING_COLLECTION_SUCCEEDED = "DELETING_COLLECTION_SUCCEEDED";
export const DELETING_COLLECTION_FAILED = "DELETING_COLLECTION_FAILED";

export const FETCH_COLLECTION_SECTION_REQUEST = "FETCH_COLLECTION_SECTION_REQUEST";
export const FETCHING_COLLECTION_SECTION_SUCCEEDED = "FETCHING_COLLECTION_SECTION_SUCCEEDED";
export const FETCHING_COLLECTION_SECTION_FAILED = "FETCHING_COLLECTION_SECTION_FAILED";

export const INVALIDATE_COLLECTION_STATE = "INVALIDATE_COLLECTION_STATE";
export const INVALIDATE_COLLECTION_CREATION_STATE =
  "INVALIDATE_COLLECTION_CREATION_STATE";
export const INVALIDATE_COLLECTION_UPDATE_STATE =
  "INVALIDATE_COLLECTION_UPDATE_STATE";
export const INVALIDATE_COLLECTION_DELETION_STATE =
  "INVALIDATE_COLLECTION_DELETION_STATE";
export const INVALIDATE_COLLECTION_MOVE_STATE =
  "INVALIDATE_COLLECTION_MOVE_STATE";

//Edit Collection
export const EDIT_COLLECTION_REQUEST = "EDIT_COLLECTION_REQUEST";
export const INVALIDATE_COLLECTION_EDIT_STATE = "INVALIDATE_COLLECTION_EDIT_STATE";

export const CREATE_COLLECTION_SECTION_REQUEST = "CREATE_COLLECTION_SECTION_REQUEST";
export const UPDATE_COLLECTION_SECTION_REQUEST = "UPDATE_COLLECTION_SECTION_REQUEST";
export const REMOVE_COLLECTION_SECTION_REQUEST = "REMOVE_COLLECTION_SECTION_REQUEST";
export const MOVE_COLLECTION_SECTION_REQUEST = "MOVE_COLLECTION_SECTION_REQUEST";

export const COLLECTION_ADD_ASSETS = "COLLECTION_ADD_ASSETS";
export const COLLECTION_REMOVE_ASSETS = "COLLECTION_REMOVE_ASSETS";
export const COLLECTION_REARRANGE_ASSETS = "COLLECTION_REARRANGE_ASSETS";
export const COLLECTION_UPDATE_ASSET_METADATA = "COLLECTION_UPDATE_ASSET_METADATA";
export const COLLECTION_MOVE_SECTIONS = "COLLECTION_MOVE_SECTIONS";

export const COLLECTION_MOVE_ASSET_TO_SECTION = "COLLECTION_MOVE_ASSET_TO_SECTION";

export const COLLECTION_UPDATE_PROPERTY = "COLLECTION_UPDATE_PROPERTY";

export const TOGGLE_COLLECTION_TEMPLATE_REQUEST = "TOGGLE_COLLECTION_TEMPLATE_REQUEST";
export const TOGGLE_COLLECTION_INTERNAL_REQUEST = "TOGGLE_COLLECTION_INTERNAL_REQUEST";
export const TOGGLE_COLLECTION_LIVE_REQUEST = "TOGGLE_COLLECTION_LIVE_REQUEST";

export const TOGGLING_COLLECTION_STATE_SUCCEEDED = "TOGGLING_COLLECTION_STATE_SUCCEEDED";
export const TOGGLING_COLLECTION_STATE_FAILED = "TOGGLING_COLLECTION_STATE_FAILED";

export const FETCH_COLLECTION_SHARED_CONTACTS_REQUEST = "FETCH_COLLECTION_SHARED_CONTACTS_REQUEST"
export const FETCHING_COLLECTION_SHARED_CONTACTS_SUCCEEDED = "FETCHING_COLLECTION_SHARED_CONTACTS_SUCCEEDED"
export const FETCHING_COLLECTION_SHARED_CONTACTS_FAILED = "FETCHING_COLLECTION_SHARED_CONTACTS_FAILED"

export const FETCH_COLLECTION_COLLABORATORS_REQUEST = "FETCH_COLLECTION_COLLABORATORS_REQUEST";
export const FETCHING_COLLECTION_COLLABORATORS_SUCCEDDED = "FETCHING_COLLECTION_COLLABORATORS_SUCCEDDED";
export const FETCHING_COLLECTION_COLLABORATORS_FAILED = "FETCHING_COLLECTION_COLLABORATORS_FAILED";
export const INVALIDATE_COLLECTION_COLLABORATORS = "INVALIDATE_COLLECTION_COLLABORATORS";

export const FETCH_COLLECTION_USER_ACCESS_REQUEST = "FETCH_COLLECTION_USER_ACCESS_REQUEST";
export const FETCHING_COLLECTION_USER_ACCESS_SUCCEDDED = "FETCHING_COLLECTION_USER_ACCESS_SUCCEDDED";
export const FETCHING_COLLECTION_USER_ACCESS_FAILED = "FETCHING_COLLECTION_USER_ACCESS_FAILED";

export const UPDATE_COLLECTION_COLLABORATORS_REQUEST = "UPDATE_COLLECTION_COLLABORATORS_REQUEST";
export const UPDATING_COLLECTION_COLLABORATORS_SUCCEDDED = "UPDATING_COLLECTION_COLLABORATORS_SUCCEDDED";
export const UPDATING_COLLECTION_COLLABORATORS_FAILED = "UPDATING_COLLECTION_COLLABORATORS_FAILED";

// Notifications
export const FETCH_NOTIFICATIONS_REQUEST = "FETCH_NOTIFICATIONS_REQUEST";
export const FETCHING_NOTIFICATIONS_SUCCEDDED ="FETCHING_NOTIFICATIONS_SUCCEDDED";
export const FETCHING_NOTIFICATIONS_FAILED = "FETCHING_NOTIFICATIONS_FAILED";

export const FETCHING_NOTIFICATIONS_COUNT_REQUEST = "FETCHING_NOTIFICATIONS_COUNT_REQUEST";
export const FETCHING_NOTIFICATIONS_COUNT_SUCCEDDED = "FETCHING_NOTIFICATIONS_COUNT_SUCCEDDED";
export const FETCHING_NOTIFICATIONS_COUNT_FAILED = "FETCHING_NOTIFICATIONS_COUNT_FAILED";

// delete notifications

export const DELETE_ALL_NOTIFICATIONS_REQUEST = "DELETE_ALL_NOTIFICATIONS_REQUEST";
export const DELETE_ALL_NOTIFICATIONS_SUCCEEDED ="DELETE_ALL_NOTIFICATIONS_SUCCEEDED";
export const DELETE_ALL_NOTIFICATIONS_FAILED = "DELETE_ALL_NOTIFICATIONS_FAILED";

//update notofiations

export const MARK_NOTIFICATIONS_AS_READ = "MARK_NOTIFICATIONS_AS_READ";
export const MARK_NOTIFICATIONS_AS_READ_SUCCEEDED ="MARK_NOTIFICATIONS_AS_READ_SUCCEEDED";
export const MARK_NOTIFICATIONS_AS_READ_FAILED = "MARK_NOTIFICATIONS_AS_READ_FAILED";

//Add asset to collection 
export const ADD_ASSETS_TO_COLLECTION_ON_SERVER = "ADD_ASSETS_TO_COLLECTION_ON_SERVER";
export const ADDING_ASSETS_TO_COLLECTION_ON_SERVER_SUCCEDDED = "ADDING_ASSETS_TO_COLLECTION_ON_SERVER_SUCCEDDED";
export const ADDING_ASSETS_TO_COLLECTION_ON_SERVER_FAILED = "ADDING_ASSETS_TO_COLLECTION_ON_SERVER_FAILED";

//Collection Sections 
export const ADD_ASSETS_TO_SECTION_ON_SERVER = "ADD_ASSETS_TO_SECTION_ON_SERVER";
export const ADD_ASSETS_TO_SECTION_ON_SERVER_SUCCEDDED = "ADD_ASSETS_TO_SECTION_ON_SERVER_SUCCEDDED";
export const ADD_ASSETS_TO_SECTION_ON_SERVER_FAILED = "ADD_ASSETS_TO_SECTION_ON_SERVER_FAILED";

export const INVALIDATE_ADD_ASSET_COLLECTIONS = "INVALIDATE_ADD_ASSET_COLLECTIONS";

//Search
export const SEARCH_COLLECTIONS_REQUEST = "SEARCH_COLLECTIONS_REQUEST";
export const SEARCHING_COLLECTIONS_SUCCEEDED = "SEARCHING_COLLECTIONS_SUCCEEDED";
export const SEARCHING_COLLECTIONS_FAILED = "SEARCHING_COLLECTIONS_FAILED";
export const INVALIDATE_COLLECTION_SEARCH_RESULTS = "INVALIDATE_COLLECTION_SEARCH_RESULTS";

export const SEARCH_STREAMS_REQUEST = "SEARCH_STREAMS_REQUEST";
export const SEARCHING_STREAMS_SUCCEEDED = "SEARCHING_STREAMS_SUCCEEDED";
export const SEARCHING_STREAMS_FAILED = "SEARCHING_STREAMS_FAILED";
export const INVALIDATE_STREAM_SEARCH_RESULTS = "INVALIDATE_STREAM_SEARCH_RESULTS";

export const SEARCH_ASSETS_REQUEST = "SEARCH_ASSETS_REQUEST";
export const SEARCHING_ASSETS_SUCCEEDED = "SEARCHING_ASSETS_SUCCEEDED";
export const SEARCHING_ASSETS_FAILED = "SEARCHING_ASSETS_FAILED";
export const INVALIDATE_ASSET_SEARCH_RESULTS = "INVALIDATE_ASSET_SEARCH_RESULTS";

export const SEARCH_GROUPS_REQUEST = "SEARCH_GROUPS_REQUEST";
export const SEARCHING_GROUPS_SUCCEDDED = "SEARCHING_GROUPS_SUCCEDDED";
export const SEARCHING_GROUPS_FAILED = "SEARCHING_GROUPS_FAILED";
export const INVALIDATE_GROUPS_SEARCH_RESULTS = "INVALIDATE_GROUPS_SEARCH_RESULTS";

export const SEARCHING_CONTACT_FOR_AUTOCOMPLETE = "SEARCHING_CONTACT_FOR_AUTOCOMPLETE";
export const SEARCHING_CONTACT_FOR_AUTOCOMPLETE_SUCCEDDED = "SEARCHING_CONTACT_FOR_AUTOCOMPLETE_SUCCEDDED";
export const SEARCHING_CONTACT_FOR_AUTOCOMPLETE_FAILED = "SEARCHING_CONTACT_FOR_AUTOCOMPLETE_FAILED";
export const INVALIDATE_AUTOCOMPLETE_CONTACT = "INVALIDATE_AUTOCOMPLETE_CONTACT";

//content map
export const FETCHING_CLUSTERS = "FETCHING_CLUSTERS";
export const FETCHING_CLUSTERS_SUCCEEDED = "FETCHING_CLUSTERS_SUCCEEDED";
export const FETCHING_CLUSTERS_FAILED = "FETCHING_CLUSTERS_FAILED";

export const FETCHING_CLUSTER = "FETCHING_CLUSTER";
export const FETCHING_CLUSTER_SUCCEEDED = "FETCHING_CLUSTER_SUCCEEDED";
export const FETCHING_CLUSTER_FAILED = "FETCHING_CLUSTER_FAILED";

export const FETCHING_ASSETS_CONTENT_MAP = "FETCHING_ASSETS_CONTENT_MAP";
export const FETCHING_ASSETS_CONTENT_MAP_SUCCEEDED = "FETCHING_ASSETS_CONTENT_MAP_SUCCEEDED";
export const FETCHING_ASSETS_CONTENT_MAP_FAILED = "FETCHING_ASSETS_CONTENT_MAP_FAILED";
export const INVALIDATE_CONTENT_MAP_ASSETS = "INVALIDATE_CONTENT_MAP_ASSETS";

export const CREATING_CLUSTER = "CREATING_CLUSTER";
export const CREATING_CLUSTER_SUCCEEDED = "CREATING_CLUSTER_SUCCEEDED";
export const CREATING_CLUSTER_FAILED = "CREATING_CLUSTER_FAILED";

export const DELETING_CLUSTER = "DELETING_CLUSTER";
export const DELETING_CLUSTER_SUCCEEDED = "DELETING_CLUSTER_SUCCEEDED";
export const DELETING_CLUSTER_FAILED = "DELETING_CLUSTER_FAILED";

export const UPDATING_CLUSTER = "UPDATING_CLUSTER";
export const UPDATING_CLUSTER_SUCCEEDED = "UPDATING_CLUSTER_SUCCEEDED";
export const UPDATING_CLUSTER_FAILED = "UPDATING_CLUSTER_FAILED";

export const DELETE_ASSETS_CONTENT_MAP = "DELETE_ASSETS_CONTENT_MAP";
export const DELETE_ASSETS_CONTENT_MAP_SUCCEEDED = "DELETE_ASSETS_CONTENT_MAP_SUCCEEDED";
export const DELETE_ASSETS_CONTENT_MAP_FAILED = "DELETE_ASSETS_CONTENT_MAP_FAILED";

export const UPDATE_ASSETS_CONTENT_MAP = "UPDATE_ASSETS_CONTENT_MAP";
export const UPDATE_ASSETS_CONTENT_MAP_SUCCEEDED = "UPDATE_ASSETS_CONTENT_MAP_SUCCEEDED";
export const UPDATE_ASSETS_CONTENT_MAP_FAILED = "UPDATE_ASSETS_CONTENT_MAP_FAILED";

// fetch assets for content score card
export const FETCHING_ASSETS_FOR_CONTENT_SCORE_CARD = "FETCHING_ASSETS_FOR_CONTENT_SCORE_CARD";
export const FETCHING_ASSETS_FOR_CONTENT_SCORE_CARD_SUCCEEDED = "FETCHING_ASSETS_FOR_CONTENT_SCORE_CARD_SUCCEEDED";
export const FETCHING_ASSETS_FOR_CONTENT_SCORE_CARD_FAILED = "FETCHING_ASSETS_FOR_CONTENT_SCORE_CARD_FAILED";

// fetch content graph values
export const FETCHING_CONTENT_GRAPH_VALUES = "FETCHING_CONTENT_GRAPH_VALUES";
export const FETCHING_CONTENT_GRAPH_VALUES_SUCCEEDED = "FETCHING_CONTENT_GRAPH_VALUES_SUCCEEDED";
export const FETCHING_CONTENT_GRAPH_VALUES_FAILED = "FETCHING_CONTENT_GRAPH_VALUES_FAILED";

// fetch content score
export const FETCHING_CONTENT_SCORE = "FETCHING_CONTENT_SCORE";
export const FETCHING_CONTENT_SCORE_SUCCEEDED = "FETCHING_CONTENT_SCORE_SUCCEEDED";
export const FETCHING_CONTENT_SCORE_FAILED = "FETCHING_CONTENT_SCORE_FAILED";

export const FETCH_ASSETS_FOR_DOWNLOAD = "FETCH_ASSETS_FOR_DOWNLOAD";
export const FETCHING_ASSETS_FOR_DOWNLOAD_SUCCEEDED = "FETCHING_ASSETS_FOR_DOWNLOAD_SUCCEEDED";
export const FETCHING_ASSETS_FOR_DOWNLOAD_FAILED = "FETCHING_ASSETS_FOR_DOWNLOAD_FAILED";
export const INVALIDATE_ASSETS_FOR_DOWNLOAD = "INVALIDATE_ASSETS_FOR_DOWNLOAD";
export const INVALIDATE_CONTENT_DATA = "INVALIDATE_CONTENT_DATA";

//delet asset
export const DELETING_ASSET_REQUEST = "DELETING_ASSET_REQUEST";
export const DELETING_ASSET_SUCCEEDED = "DELETING_ASSET_SUCCEEDED";
export const DELETING_ASSET_FAILED = "DELETING_ASSET_FAILED";

//delete group
export const DELETING_GROUP_REQUEST = "DELETING_GROUP_REQUEST";
export const DELETING_GROUP_SUCCEEDED = "DELETING_GROUP_SUCCEEDED";
export const DELETING_GROUP_FAILED = "DELETING_GROUP_FAILED";

//sort stream
export const SORTING_STREAM = "SORTING_STREAM";

//sort group
export const SORTING_GROUP = "SORTING_GROUP";

//update stream property
export const STREAM_UPDATE_PROPERTY = "STREAM_UPDATE_PROPERTY";

//update group property
export const GROUP_UPDATE_PROPERTY = "GROUP_UPDATE_PROPERTY";

//add asset to stream
export const ADD_ASSET_TO_STREAM = "ADD_ASSET_TO_STREAM";
export const ADD_ASSET_TO_STREAM_SUCCEDDED = "ADD_ASSET_TO_STREAM_SUCCEDDED";
export const ADD_ASSET_TO_STREAM_FAILED = "ADD_ASSET_TO_STREAM_FAILED";

//create group in stream
export const CREATING_GROUP_IN_STREAM = "CREATING_GROUP_IN_STREAM";
export const CREATING_GROUP_IN_STREAM_SUCCEEDED = "CREATING_GROUP_IN_STREAM_SUCCEEDED";
export const CREATING_GROUP_IN_STREAM_FAILED = "CREATING_GROUP_IN_STREAM_FAILED";

//tracking stream viewed event
export const RECORDING_STREAMED_VIEW = "RECORDING_STREAMED_VIEW";
export const RECORDING_STREAM_VIEWED_SUCCEEDED = "RECORDING_STREAM_VIEWED_SUCCEEDED";
export const RECORDING_STREAM_VIEWED_FAILED = "RECORDING_STREAM_VIEWED_FAILED";

//add asset to group
export const ADD_ASSET_TO_GROUP = "ADD_ASSET_TO_GROUP";
export const ADD_ASSET_TO_GROUP_SUCCEEDED = "ADD_ASSET_TO_GROUP_SUCCEEDED";
export const ADD_ASSET_TO_GROUP_FAILED = "ADD_ASSET_TO_GROUP_FAILED";

//create group in group
export const CREATING_GROUP_IN_GROUP = "CREATING_GROUP_IN_GROUP";
export const CREATING_GROUP_IN_GROUP_SUCCEEDED = "CREATING_GROUP_IN_GROUP_SUCCEEDED";
export const CREATING_GROUP_IN_GROUP_FAILED = "CREATING_GROUP_IN_GROUP_FAILED";

//fetch data sources
export const FETCHING_DATA_SOURCES_REQUEST = "FETCHING_DATA_SOURCES_REQUEST";
export const FETCHING_DATA_SOURCES_SUCCEEDED = "FETCHING_DATA_SOURCES_SUCCEEDED";
export const FETCHING_DATA_SOURCES_FAILED = "FETCHING_DATA_SOURCES_FAILED";

//fetch data source mappings
export const FETCHING_DATA_SOURCE_MAPPINGS_REQUEST = "FETCHING_DATA_SOURCE_MAPPINGS_REQUEST";
export const FETCHING_DATA_SOURCE_MAPPINGS_SUCCEEDED = "FETCHING_DATA_SOURCE_MAPPINGS_SUCCEEDED";
export const FETCHING_DATA_SOURCE_MAPPINGS_FAILED = "FETCHING_DATA_SOURCE_MAPPINGS_FAILED";

//fetch data source children
export const FETCHING_DATA_SOURCE_CHILDREN_REQUEST = "FETCHING_DATA_SOURCE_CHILDREN_REQUEST";
export const FETCHING_DATA_SOURCE_CHILDREN_SUCCEEDED = "FETCHING_DATA_SOURCE_CHILDREN_SUCCEEDED";
export const FETCHING_DATA_SOURCE_CHILDREN_FAILED = "FETCHING_DATA_SOURCE_CHILDREN_FAILED";

//create data source mapping
export const CREATING_DATA_SOURCE_MAPPING_REQUEST = "CREATING_DATA_SOURCE_MAPPING_REQUEST";
export const CREATING_DATA_SOURCE_MAPPING_SUCCEEDED = "CREATING_DATA_SOURCE_MAPPING_SUCCEEDED";
export const CREATING_DATA_SOURCE_MAPPING_FAILED = "CREATING_DATA_SOURCE_MAPPING_FAILED";


//sync data source mapping
export const SYNCING_DATA_SOURCE_MAPPING_REQUEST = "SYNCING_DATA_SOURCE_MAPPING_REQUEST";
export const SYNCING_DATA_SOURCE_MAPPING_SUCCEEDED = "SYNCING_DATA_SOURCE_MAPPING_SUCCEEDED";
export const SYNCING_DATA_SOURCE_MAPPING_FAILED = "SYNCING_DATA_SOURCE_MAPPING_FAILED";

//delete data source mapping
export const DELETING_DATA_SOURCE_MAPPING_REQUEST = "DELETING_DATA_SOURCE_MAPPING_REQUEST";
export const DELETING_DATA_SOURCE_MAPPING_SUCCEEDED = "DELETING_DATA_SOURCE_MAPPING_SUCCEEDED";
export const DELETING_DATA_SOURCE_MAPPING_FAILED = "DELETING_DATA_SOURCE_MAPPING_FAILED";

//invalidate data source mapping
export const INVALIDATE_DATA_SOURCE_SYNC = "INVALIDATE_DATA_SOURCE_SYNC";

//invalidate data source deletion
export const INVALIDATE_DATA_SOURCE_DELETION = "INVALIDATE_DATA_SOURCE_DELETION";

//invalidate data source migration status
export const INVALIDATE_DATA_SOURCE_MIGRATION_STATUS = "INVALIDATE_DATA_SOURCE_MIGRATION_STATUS";

//authenticate data source 
export const AUTHENTICATING_DATA_SOURCE = "AUTHENTICATING_DATA_SOURCE";
export const AUTHENTICATING_DATA_SOURCE_SUCCEEDED = "AUTHENTICATING_DATA_SOURCE_SUCCEEDED";
export const AUTHENTICATING_DATA_SOURCE_FAILED = "AUTHENTICATING_DATA_SOURCE_FAILED";

//deleting data source
export const DELETING_DATA_SOURCE = "DELETING_DATA_SOURCE";
export const DELETING_DATA_SOURCE_SUCCEEDED = "DELETING_DATA_SOURCE_SUCCEEDED";
export const DELETING_DATA_SOURCE_FAILED = "DELETING_DATA_SOURCE_FAILED";

//sync data source 
export const SYNCING_DATA_SOURCE = "SYNCING_DATA_SOURCE";
export const SYNCING_DATA_SOURCE_SUCCEEDED = "SYNCING_DATA_SOURCE_SUCCEEDED";
export const SYNCING_DATA_SOURCE_FAILED = "SYNCING_DATA_SOURCE_FAILED";

//migrate data source
export const MIGRATING_DATA_SOURCE = "MIGRATING_DATA_SOURCE";
export const MIGRATING_DATA_SOURCE_SUCCEEDED = "MIGRATING_DATA_SOURCE_SUCCEEDED";
export const MIGRATING_DATA_SOURCE_FAILED = "MIGRATING_DATA_SOURCE_FAILED";

//create rss data source
export const CREATING_RSS_DATA_SOURCE = "CREATING_RSS_DATA_SOURCE";
export const CREATING_RSS_DATA_SOURCE_SUCCEEDED = "CREATING_RSS_DATA_SOURCE_SUCCEEDED";
export const CREATING_RSS_DATA_SOURCE_FAILED = "CREATING_RSS_DATA_SOURCE_FAILED";

//data source migration status
export const WS_DATASOURCE_MIGRATION_STATUS = "WS_DATASOURCE_MIGRATION_STATUS";

//data source migration completion
export const WS_DATASOURCE_MIGRATION_COMPLETION = "WS_DATASOURCE_MIGRATION_COMPLETION";

//coping entities 
export const COPYING_ENTITY_REQUEST = "COPYING_ENTITY_REQUEST";
export const COPYING_ENTITY_SUCCEEDED = "COPYING_ENTITY_SUCCEEDED";
export const COPYING_ENTITY_FAILED = "COPYING_ENTITY_FAILED";

//moving entities 
export const MOVING_ENTITY_REQUEST = "MOVING_ENTITY_REQUEST";
export const MOVING_ENTITY_SUCCEEDED = "MOVING_ENTITY_SUCCEEDED";
export const MOVING_ENTITY_FAILED = "MOVING_ENTITY_FAILED";

//delete asset from stream
export const DELETING_ASSET_FROM_STREAM_REQUEST = "DELETING_ASSET_FROM_STREAM_REQUEST";
export const DELETING_ASSET_FROM_STREAM_SUCCEEDED = "DELETING_ASSET_FROM_STREAM_SUCCEEDED";
export const DELETING_ASSET_FROM_STREAM_FAILED = "DELETING_ASSET_FROM_STREAM_FAILED";

//fetch group
export const FETCHING_GROUP_REQUEST = "FETCHING_GROUP_REQUEST";
export const FETCHING_GROUP_SUCCEEDED = "FETCHING_GROUP_SUCCEEDED";
export const FETCHING_GROUP_FAILED = "FETCHING_GROUP_FAILED";

//fetch group children
export const FETCHING_GROUP_CHILDREN_REQUEST = "FETCHING_GROUP_CHILDREN_REQUEST";
export const FETCHING_GROUP_CHILDREN_SUCCEEDED = "FETCHING_GROUP_CHILDREN_SUCCEEDED";
export const FETCHING_GROUP_CHILDREN_FAILED = "FETCHING_GROUP_CHILDREN_FAILED";
export const INVALIDATE_GROUP_CHILDREN_FETCHED = "INVALIDATE_GROUP_CHILDREN_FETCHED"

//deleting asset from group
export const DELETING_ASSET_FROM_GROUP_REQUEST = "DELETING_ASSET_FROM_GROUP_REQUEST";
export const DELETING_ASSET_FROM_GROUP_SUCCEEDED = "DELETING_ASSET_FROM_GROUP_SUCCEEDED";
export const DELETING_ASSET_FROM_GROUP_FAILED = "DELETING_ASSET_FROM_GROUP_FAILED";

//Media Library
export const FETCH_MEDIA_LIBRARY = "FETCH_MEDIA_LIBRARY";
export const FETCHING_MEDIA_LIBRARY_SUCCEEDED = "FETCHING_MEDIA_LIBRARY_SUCCEEDED";
export const FETCHING_MEDIA_LIBRARY_FAILED = "FETCHING_MEDIA_LIBRARY_FAILED";

export const FETCH_MEDIA_LIBRARY_CATEGORIES = "FETCH_MEDIA_LIBRARY_CATEGORIES";
export const FETCHING_MEDIA_LIBRARY_CATEGORIES_SUCCEEDED = "FETCHING_MEDIA_LIBRARY_CATEGORIES_SUCCEEDED";
export const FETCHING_MEDIA_LIBRARY_CATEGORIES_FAILED = "FETCHING_MEDIA_LIBRARY_CATEGORIES_FAILED";

export const FETCH_EXTERNAL_MEDIA_LIBRARY = "FETCH_EXTERNAL_MEDIA_LIBRARY";
export const FETCHING_EXTERNAL_MEDIA_LIBRARY_SUCCEEDED = "FETCHING_EXTERNAL_MEDIA_LIBRARY_SUCCEEDED";
export const FETCHING_EXTERNAL_MEDIA_LIBRARY_FAILED = "FETCHING_EXTERNAL_MEDIA_LIBRARY_FAILED";

//Media
export const UPLOAD_MEDIA_REQUEST = "UPLOAD_MEDIA_REQUEST";
export const UPLOADING_MEDIA_SUCCEEDED = "UPLOADING_MEDIA_SUCCEEDED";
export const UPLOADING_MEDIA_FAILED = "UPLOADING_MEDIA_FAILED";
export const INVALIDATE_MEDIA_UPLOAD = "INVALIDATE_MEDIA_UPLOAD";

//Microsoft Wopi Integration
export const FETCHING_WOPI_INTEGRATION_ASSET_DETAILS_REQUEST = "FETCHING_WOPI_INTEGRATION_ASSET_DETAILS_REQUEST";
export const FETCHING_WOPI_INTEGRATION_ASSET_DETAILS_SUCCEDDED = "FETCHING_WOPI_INTEGRATION_ASSET_DETAILS_SUCCEDDED";
export const FETCHING_WOPI_INTEGRATION_ASSET_DETAILS_FAILED = "FETCHING_WOPI_INTEGRATION_ASSET_DETAILS_FAILED";

export const UPDATING_WOPI_INTEGRATION_ASSET_REQUEST = "UPDATING_WOPI_INTEGRATION_ASSET_REQUEST";
export const UPDATING_WOPI_INTEGRATION_ASSET_SUCCEDDED = "UPDATING_WOPI_INTEGRATION_ASSET_SUCCEDDED";
export const UPDATING_WOPI_INTEGRATION_ASSET_FAILED = "UPDATING_WOPI_INTEGRATION_ASSET_FAILED";

export const INVALIDATE_WOPI_INTEGRATION = "INVALIDATE_WOPI_INTEGRATION";

//GDocs Integration
export const CREATE_GDOC_ASSET_EDITOR_REFERENCE_REQUEST = 'CREATE_GDOC_ASSET_EDITOR_REFERENCE_REQUEST';
export const CREATING_GDOC_ASSET_EDITOR_REFERENCE_SUCCEDDED = 'CREATING_GDOC_ASSET_EDITOR_REFERENCE_SUCCEDDED';
export const CREATING_GDOC_ASSET_EDITOR_REFERENCE_FAILED = 'CREATING_GDOC_ASSET_EDITOR_REFERENCE_FAILED';
export const WS_ASSET_EDITOR_CREATED = "WS_ASSET_EDITOR_CREATED";
export const SYNC_GDOC_ASSET_EDITOR_REFERENCE_REQUEST = "SYNC_GDOC_ASSET_EDITOR_REFERENCE_REQUEST";
export const SYNCING_GDOC_ASSET_EDITOR_REFERENCE_SUCCEDDED ="SYNCING_GDOC_ASSET_EDITOR_REFERENCE_SUCCEDDED";
export const SYNCING_GDOC_ASSET_EDITOR_REFERENCE_FAILED = "SYNCING_GDOC_ASSET_EDITOR_REFERENCE_FAILED";
export const INVALIDATE_GDOC_ASSET_EDITOR_REFERENCE = "INVALIDATE_GDOC_ASSET_EDITOR_REFERENCE";

//Links
export const GENERATE_LINK_REQUEST = "GENERATE_LINK_REQUEST";
export const GENERATE_LINK_SUCCEEDED = "GENERATE_LINK_SUCCEEDED";
export const GENERATE_LINK_FAILED = "GENERATE_LINK_FAILED";

export const FETCH_NDA_TEMPLATES_REQUEST = "FETCH_NDA_TEMPLATES_REQUEST";
export const FETCHING_NDA_TEMPLATES_SUCCEEDED = "FETCHING_NDA_TEMPLATES_SUCCEEDED";
export const FETCHING_NDA_TEMPLATES_FAILED = "FETCHING_NDA_TEMPLATES_FAILED";

export const UPDATE_LINK_REQUEST = "UPDATE_LINK_REQUEST";
export const UPDATING_LINK_SUCCEEDED = "UPDATING_LINK_SUCCEEDED";
export const UPDATING_LINK_FAILED = "UPDATING_LINK_FAILED";
export const INVALIDATE_LINK_UPDATIONS = "INVALIDATE_ALL_UPDATIONS";

export const FETCH_ALL_LINKS_REQUEST = "FETCH_ALL_LINKS_REQUEST";
export const FETCHING_ALL_LINKS_SUCCEEDED = "FETCHING_ALL_LINKS_SUCCEEDED";
export const FETCHING_ALL_LINKS_FAILED = "FETCHING_ALL_LINKS_FAILED";
export const INVALIDATE_ALL_LINK_ITEMS = "INVALIDATE_ALL_LINK_ITEMS";

export const DELETE_LINK_REQUEST = "DELETE_LINK_REQUEST";
export const DELETING_LINK_SUCCEEDED = "DELETING_LINK_SUCCEEDED";
export const DELETING_LINK_FAILED = "DELETING_LINK_FAILED";

export const RESET_GENERATE_LINK_STATE = "RESET_GENERATE_LINK_STATE";

export const WS_DATASOURCE_SYNC_STATUS = "WS_DATASOURCE_SYNC_STATUS";

//create asset
export const SELECT_ASSET_PAGE = "SELECT_ASSET_PAGE";
export const REMOVE_ASSET_PAGE = "REMOVE_ASSET_PAGE";
export const INVALIDATE_SELECTED_ASSET_PAGES = "INVALIDATE_SELECTED_ASSET_PAGES";
export const REARRANGE_ASSET_PAGES = " REARRANGE_ASSET_PAGES";

export const CREATING_ASSET_FROM_HUB = "CREATING_ASSET_FROM_HUB";
export const CREATING_ASSET_FROM_HUB_SUCCEEDED = "CREATING_ASSET_FROM_HUB_SUCCEEDED";
export const CREATING_ASSET_FROM_HUB_FAILED = "CREATING_ASSET_FROM_HUB_FAILED";

export const MODIFY_PAGES_IN_ASSET = "MODIFY_PAGES_IN_ASSET";
export const MODIFYING_PAGES_IN_ASSET_SUCCEEDED = "MODIFYING_PAGES_IN_ASSET_SUCCEEDED";
export const MODIFYING_PAGES_IN_ASSET_FAILED = "MODIFYING_PAGES_IN_ASSET_FAILED";

//seek
export const FETCH_ANSWER_FOR_SEEK_REQUEST = "FETCH_ANSWER_FOR_SEEK_REQUEST";
export const FETCHING_ANSWER_FOR_SEEK_SUCCEEDED = "FETCHING_ANSWER_FOR_SEEK_SUCCEEDED";
export const FETCHING_ANSWER_FOR_SEEK_FAILED = "FETCHING_ANSWER_FOR_SEEK_FAILED";

export const FETCH_SEEK_SESSIONS_REQUEST = "FETCH_SEEK_SESSIONS_REQUEST";
export const FETCHING_SEEK_SESSIONS_SUCCEEDED = "FETCHING_SEEK_SESSIONS_SUCCEEDED";
export const FETCHING_SEEK_SESSIONS_FAILED = "FETCHING_SEEK_SESSIONS_FAILED";

export const DELETE_SEEK_SESSION_REQUEST = "DELETE_SEEK_SESSION_REQUEST";
export const DELETING_SEEK_SESSION_SUCCEEDED = "DELETING_SEEK_SESSION_SUCCEEDED";
export const DELETING_SEEK_SESSION_FAILED = "DELETING_SEEK_SESSION_FAILED";

export const DELETE_SEEK_SESSIONS_REQUEST = "DELETE_SEEK_SESSIONS_REQUEST";
export const DELETING_SEEK_SESSIONS_SUCCEEDED = "DELETING_SEEK_SESSIONS_SUCCEEDED";
export const DELETING_SEEK_SESSIONS_FAILED = "DELETING_SEEK_SESSIONS_FAILED";

export const FETCH_SEEK_SESSION_REQUEST = "FETCH_SEEK_SESSION_REQUEST";
export const FETCHING_SEEK_SESSION_SUCCEEDED = "FETCHING_SEEK_SESSION_SUCCEEDED";
export const FETCHING_SEEK_SESSION_FAILED = "FETCHING_SEEK_SESSION_FAILED";
export const INVALIDATE_SEEK_SESSION = "INVALIDATE_SEEK_SESSION";

export const FETCH_SEEK_EMAIL_RESPONSE = "FETCH_SEEK_EMAIL_RESPONSE";
export const FETCHING_SEEK_EMAIL_RESPONSE_SUCCEEDED = "FETCHING_SEEK_EMAIL_RESPONSE_SUCCEEDED";
export const FETCHING_SEEK_EMAIL_RESPONSE_FAILED = "FETCHING_SEEK_EMAIL_RESPONSE_FAILED";
export const INVALIDATE_SEEK_EMAIL_RESPONSE = "INVALIDATE_SEEK_EMAIL_RESPONSE";

export const UPDATE_SEEK_FEEDBACK = "UPDATE_SEEK_FEEDBACK";
export const UPDATING_SEEK_FEEDBACK_SUCCEEDED = "UPDATING_SEEK_FEEDBACK_SUCCEEDED";
export const UPDATING_SEEK_FEEDBACK_FAILED = "UPDATING_SEEK_FEEDBACK_FAILED";

export const FETCH_SEEK_LIMIT = "FETCH_SEEK_LIMIT";
export const FETCHING_SEEK_LIMIT_SUCCEEDED = "FETCHING_SEEK_LIMIT_SUCCEEDED";
export const FETCHING_SEEK_LIMIT_FAILED = "FETCHING_SEEK_LIMIT_FAILED";

export const FETCH_SEEK_PROMPTS = "FETCH_SEEK_PROMPTS";
export const FETCHING_SEEK_PROMPTS_SUCCEEDED = "FETCHING_SEEK_PROMPTS_SUCCEEDED";
export const FETCHING_SEEK_PROMPTS_FAILED = "FETCHING_SEEK_PROMPTS_FAILED";

export const FETCH_ASSET_SUMMARY = "FETCH_ASSET_SUMMARY";
export const FETCHING_ASSET_SUMMARY_SUCCEEDED = "FETCHING_ASSET_SUMMARY_SUCCEEDED";
export const FETCHING_ASSET_SUMMARY_FAILED = "FETCHING_ASSET_SUMMARY_FAILED";

export const FETCH_ASSET_PROMPTS = "FETCH_ASSET_PROMPTS";
export const FETCHING_ASSET_PROMPTS_SUCCEEDED = "FETCHING_ASSET_PROMPTS_SUCCEEDED";
export const FETCHING_ASSET_PROMPTS_FAILED = "FETCHING_ASSET_PROMPTS_FAILED";

export const TOGGLE_SEEK = "TOGGLE_SEEK";

export const HIDE_SIDE_MENU = "HIDE_SIDE_MENU";

//create stream
export const CREATING_STREAM = "CREATING_STREAM";
export const CREATING_STREAM_SUCCEEDED = "CREATING_STREAM_SUCCEEDED";
export const CREATING_STREAM_FAILED = "CREATING_STREAM_FAILED";

//invalidate create stream
export const INVALIDATE_STREAM_CREATION = "INVALIDATE_STREAM_CREATION";


//deal room

export const CREATE_DEAL_ROOM = "CREATE_DEAL_ROOM";
export const CREATING_DEAL_ROOM_SUCCEEDED = "CREATING_DEAL_ROOM_SUCCEEDED";
export const CREATING_DEAL_ROOM_FAILED = "CREATING_DEAL_ROOM_FAILED";

export const FETCH_DEAL_ROOMS = "FETCH_DEAL_ROOMS";
export const FETCH_DEAL_ROOMS_SUCCEEDED = "FETCH_DEAL_ROOMS_SUCCEEDED";
export const FETCH_DEAL_ROOMS_FAILED = "FETCH_DEAL_ROOMS_FAILED";

export const FETCH_DEAL_ROOM = "FETCH_DEAL_ROOM";
export const FETCHING_DEAL_ROOM_SUCCEEDED = "FETCHING_DEAL_ROOM_SUCCEEDED";
export const FETCHING_DEAL_ROOM_FAILED = "FETCHING_DEAL_ROOM_FAILED";

export const DELETE_DEAL_ROOM = "DELETE_DEAL_ROOM";
export const DELETING_DEAL_ROOM_SUCCEEDED = "DELETING_DEAL_ROOM_SUCCEEDED";
export const DELETING_DEAL_ROOM_FAILED = "DELETING_DEAL_ROOM_FAILED";

export const UPDATE_DEAL_ROOM = "UPDATE_DEAL_ROOM";
export const UPDATING_DEAL_ROOM_SUCCEEDED = "UPDATING_DEAL_ROOM_SUCCEEDED";
export const UPDATING_DEAL_ROOM_FALIED = "UPDATING_DEAL_ROOM_FALIED";

export const SEARCH_DEAL_ROOMS = "SEARCH_DEAL_ROOMS";
export const SEARCHING_DEAL_ROOMS_SUCCEEDED = "SEARCHING_DEAL_ROOMS_SUCCEEDED";
export const SEARCHING_DEAL_ROOMS_FAILED = "SEARCHING_DEAL_ROOMS_FAILED";

export const INVALIDATE_DEAL_ROOMS = "INVALIDATE_DEAL_ROOMS";
export const INVALIDATE_DEAL_ROOMS_SEARCH_RESULTS = "INVALIDATE_DEAL_ROOMS_SEARCH_RESULTS";
export const INVALIDATE_DEAL_ROOMS_UPDATION = "INVALIDATE_DEAL_ROOMS_UPDATION";
export const INVALIDATE_DEAL_ROOMS_DELETION = "INVALIDATE_DEAL_ROOMS_DELETION";
//fetch user management list
export const FETCHING_USER_MANAGEMENET_LIST = "FETCHING_USER_MANAGEMENET_LIST";
export const FETCHING_USER_MANAGEMENET_LIST_SUCCEEDED = "FETCHING_USER_MANAGEMENET_LIST_SUCCEEDED";
export const FETCHING_USER_MANAGEMENET_LIST_FAILED = "FETCHING_USER_MANAGEMENET_LIST_FAILED";
//cleverStory
export const FETCHING_ACTIVATED_WORKSPACES = "FETCHING_ACTIVATED_WORKSPACES";
export const FETCHING_ACTIVATED_WORKSPACES_SUCCEEDED = "FETCHING_ACTIVATED_WORKSPACES_SUCCEEDED";
export const FETCHING_ACTIVATED_WORKSPACES_FAILED = "FETCHING_ACTIVATED_WORKSPACES_FAILED";
export const INVALIDATE_CLEVERSTORY_WORKSPACES = "INVALDATE_CLEVERSTORY_WORKSPACES"

export const FETCH_STORYBOARDS_REQUEST = "FETCH_STORYBOARDS_REQUEST"
export const FETCHING_STORYBOARDS_SUCCEEDED = "FETCHING_STORYBOARDS_SUCCEEDED"
export const FETCHING_STORYBOARDS_FAILED = "FETCHING_STORYBOARDS_FAILED"

export const FETCH_PAGES_FOR_STORYBOARD_REQUEST = "FETCH_PAGES_FOR_STORYBOARD_REQUEST"
export const FETCHING_PAGES_FOR_STORYBOARD_SUCCEEDED = "FETCHING_PAGES_FOR_STORYBOARD_SUCCEEDED"
export const FETCHING_PAGES_FOR_STORYBOARD_FAILED = "FETCHING_PAGES_FOR_STORYBOARD_FAILED"

export const CREATE_ASSET_FROM_STORYBOARD_REQUEST = "CREATE_ASSET_FROM_STORYBOARD_REQUEST"
export const CREATING_ASSET_FROM_STORYBOARD_SUCCEEDED = "CREATING_ASSET_FROM_STORYBOARD_SUCCEEDED"
export const CREATING_ASSET_FROM_STORYBOARD_FAILED = "CREATING_ASSET_FROM_STORYBOARD_FAILED"

export const INVALIDATE_CLEVERSTORY_ASSETS = "INVALIDATE_CLEVERSTORY_ASSETS"

//Conversation
export const CREATE_CONVERSATION_REQUEST = "CREATE_CONVERSATION_REQUEST";
export const CREATING_CONVERSATION_SUCCEEDED = "CREATING_CONVERSATION_SUCCEEDED";
export const CREATING_CONVERSATION_FAILED = "CREATING_CONVERSATION_FAILED";

export const INVALIDATE_CREATE_CONVERSATION = "INVALIDATE_CREATE_CONVERSATION";
export const FETCH_CONVERSATIONS_REQUEST = "FETCH_CONVERSATIONS_REQUEST";
export const FETCHING_CONVERSATIONS_SUCCEEDED = "FETCHING_CONVERSATIONS_SUCCEEDED";
export const FETCHING_CONVERSATIONS_FAILED = "FETCHING_CONVERSATIONS_FAILED";

export const FETCH_CONVERSATION_REQUEST = "FETCH_CONVERSATION_REQUEST";
export const FETCHING_CONVERSATION_SUCCEEDED = "FETCHING_CONVERSATION_SUCCEEDED";
export const FETCHING_CONVERSATION_FAILED = "FETCHING_CONVERSATION_FAILED";

export const EDIT_CONVERSATION_REQUEST = "EDIT_CONVERSATION_REQUEST";

export const FETCH_ASSETS_FOR_CONVERSATION_REQUEST = "FETCH_ASSETS_FOR_CONVERSATION_REQUEST";
export const FETCHING_ASSETS_FOR_CONVERSATION_SUCCEDDED = "FETCHING_ASSETS_FOR_CONVERSATION_SUCCEDDED";
export const FETCHING_ASSETS_FOR_CONVERSATION_FAILED = "FETCHING_ASSETS_FOR_CONVERSATION_FAILED";

export const FETCH_RECIPIENTS_FOR_CONVERSATION_REQUEST = "FETCH_RECIPIENTS_FOR_CONVERSATION_REQUEST";
export const FETCHING_RECIPIENTS_FOR_CONVERSATION_SUCCEDDED = "FETCHING_RECIPIENTS_FOR_CONVERSATION_SUCCEDDED";
export const FETCHING_RECIPIENTS_FOR_CONVERSATION_FAILED = "FETCHING_RECIPIENTS_FOR_CONVERSATION_FAILED";

export const FETCH_CONVERSATION_SECTION_REQUEST = "FETCH_CONVERSATION_SECTION_REQUEST";
export const FETCHING_CONVERSATION_SECTION_SUCCEEDED = "FETCHING_CONVERSATION_SECTION_SUCCEEDED";
export const FETCHING_CONVERSATION_SECTION_FAILED = "FETCHING_CONVERSATION_SECTION_FAILED";

export const CREATE_CONVERSATION_SECTION_REQUEST = "CREATE_CONVERSATION_SECTION_REQUEST";
export const UPDATE_CONVERSATION_SECTION_REQUEST = "UPDATE_CONVERSATION_SECTION_REQUEST";
export const REMOVE_CONVERSATION_SECTION_REQUEST = "REMOVE_CONVERSATION_SECTION_REQUEST";
export const MOVE_CONVERSATION_SECTION_REQUEST = "MOVE_CONVERSATION_SECTION_REQUEST";

export const CONVERSATION_ADD_ASSETS = "CONVERSATION_ADD_ASSETS";
export const CONVERSATION_REMOVE_ASSETS = "CONVERSATION_REMOVE_ASSETS";
export const CONVERSATION_REARRANGE_ASSETS = "CONVERSATION_REARRANGE_ASSETS";
export const CONVERSATION_UPDATE_ASSET_METADATA = "CONVERSATION_UPDATE_ASSET_METADATA";
export const CONVERSATION_MOVE_SECTIONS = "CONVERSATION_MOVE_SECTIONS";

export const CONVERSATION_MOVE_ASSET_TO_SECTION = "CONVERSATION_MOVE_ASSET_TO_SECTION";

export const CONVERSATION_UPDATE_PROPERTY = "CONVERSATION_UPDATE_PROPERTY";

export const INVALIDATE_CONVERSATION_EDIT_STATE = "INVALIDATE_CONVERSATION_EDIT_STATE";

export const UPDATE_CONVERSATION_REQUEST = "UPDATE_CONVERSATION_REQUEST";
export const UPDATING_CONVERSATION_SUCCEEDED = "UPDATING_CONVERSATION_SUCCEEDED";
export const UPDATING_CONVERSATION_FAILED = "UPDATING_CONVERSATION_FAILED";

export const REMOVE_OPPORTUNITY_FROM_SHARE = "REMOVE_OPPORTUNITY_FROM_SHARE";
export const REMOVING_OPPORTUNITY_FROM_SHARE_SUCCEEDED = "REMOVING_OPPORTUNITY_FROM_SHARE_SUCCEEDED";
export const REMOVING_OPPORTUNITY_FROM_SHARE_FAILED = "REMOVING_OPPORTUNITY_FROM_SHARE_FAILED";

export const FETCH_RECIPIENT_INFO_FOR_CONVERSATION_REQUEST = "FETCH_RECIPIENT_INFO_FOR_CONVERSATION_REQUEST";
export const FETCHING_RECIPIENT_INFO_FOR_CONVERSATION_SUCCEDDED = "FETCHING_RECIPIENT_INFO_FOR_CONVERSATION_SUCCEDDED";
export const FETCHING_RECIPIENT_INFO_FOR_CONVERSATION_FAILED = "FETCHING_RECIPIENT_INFO_FOR_CONVERSATION_FAILED";

export const UPDATE_CONVERSATION_RECIPENT_REQUEST = "UPDATE_CONVERSATION_RECIPENT_REQUEST";
export const UPDATING_CONVERSATION_RECIPENT_SUCCEEDED = "UPDATING_CONVERSATION_RECIPENT_SUCCEEDED";
export const UPDATING_CONVERSATION_RECIPENT_FAILED = "UPDATING_CONVERSATION_RECIPENT_FAILED";

export const TOGGLE_VISITOR_SESSION = "TOGGLE_VISITOR_SESSION";

export const FETCH_CONVERSATION_EVENTS = "FETCHING_CONVERSATION_EVENTS";
export const FETCHING_CONVERSATION_EVENTS_SUCCEEDED = "FETCHING_CONVERSATION_EVENTS_SUCCEEDED";
export const FETCHING_CONVERSATION_EVENTS_FAILED = "FETCHING_CONVERSATION_EVENTS_FAILED";

export const SEARCHING_ENTITIES_IN_SHARE_REQUEST = "SEARCHING_ENTITIES_IN_SHARE_REQUEST"
export const SEARCHING_ENTITIES_IN_SHARE_SUCCEEDED = "SEARCHING_ENTITIES_IN_SHARE_SUCCEEDED"
export const SEARCHING_ENTITIES_IN_SHARE_FAILED = "SEARCHING_ENTITIES_IN_SHARE_FAILED"

export const ADD_OPPORTUNITY_TO_SHARE = "ADD_OPPORTUNITY_TO_SHARE"
export const ADDING_OPPORTUNITY_TO_SHARE_SUCCEEDED = "ADDING_OPPORTUNITY_TO_SHARE_SUCCEEDED"
export const ADDING_OPPORTUNITY_TO_SHARE_FAILED = "ADDING_OPPORTUNITY_TO_SHARE_FAILED"

export const DELETE_CONVERSATION_REQUEST = "DELETE_CONVERSATION_REQUEST"
export const DELETING_CONVERSATION_SUCCEEDED = "DELETING_CONVERSATION_SUCCEEDED"
export const DELETING_CONVERSATION_FAILED = "DELETING_CONVERSATION_FAILED"

export const FETCH_MESSAGE_REQUEST = "FETCH_MESSAGE_REQUEST"
export const FETCHING_MESSAGE_SUCCEEDED = "FETCHING_MESSAGE_SUCCEEDED"
export const FETCHING_MESSAGE_FAILED = "FETCHING_MESSAGE_FAILED"

export const RESEND_CONVERSATION_REQUEST = "RESEND_CONVERSATION_REQUEST"
export const RESENDING_CONVERSATION_SUCCEEDED = "RESENDING_CONVERSATION_SUCCEEDED"
export const RESENDING_CONVERSATION_FAILED = "RESENDING_CONVERSATION_FAILED"

export const INVALIDATE_RESHARE = "INVALIDATE_RESHARE"

export const FETCH_CONVERSATION_ASSET_ANALYTICS_REQUEST = "FETCHING_CONVERSATION_ASSET_ANALYTICS_REQUEST";
export const FETCHING_CONVERSATION_ASSET_ANALYTICS_SUCCEEDED = "FETCHING_CONVERSATION_ASSET_ANALYTICS_SUCCEEDED";
export const FETCHING_CONVERSATION_ASSET_ANALYTICS_FAILED = "FETCHING_CONVERSATION_ASSET_ANALYTICS_FAILED";

export const FETCH_CONVERSATION_ASSETS_REQUEST = "FETCH_CONVERSATION_ASSETS_REQUEST"
export const FETCHING_CONVERSATION_ASSETS_SUCCEEDED = "FETCHING_CONVERSATION_ASSETS_SUCCEEDED"
export const FETCHING_CONVERSATION_ASSETS_FAILED = "FETCHING_CONVERSATION_ASSETS_FAILED"

export const FETCH_ASSETS_FOR_SECTION = "FETCH_ASSETS_FOR_SECTION"
export const FETCHING_ASSETS_FOR_SECTION_SUCCEEDED = "FETCHING_ASSETS_FOR_SECTION_SUCCEEDED"
export const FETCHING_ASSETS_FOR_SECTION_FAILED = "FETCHING_ASSETS_FOR_SECTION_FAILED"

export const INVALIDATE_CONVERSATION_STATE = "INVALIDATE_CONVERSATION_STATE"
//Add asset to conversation 
export const ADD_ASSETS_TO_CONVERSATION_ON_SERVER = "ADD_ASSETS_TO_CONVERSATION_ON_SERVER";
export const ADDING_ASSETS_TO_CONVERSATION_ON_SERVER_SUCCEDDED = "ADDING_ASSETS_TO_CONVERSATION_ON_SERVER_SUCCEDDED";
export const ADDING_ASSETS_TO_CONVERSATION_ON_SERVER_FAILED = "ADDING_ASSETS_TO_CONVERSATION_ON_SERVER_FAILED";

//Add asset to conversation sections 
export const ADD_ASSETS_TO_CONVERSATION_SECTION_ON_SERVER = "ADD_ASSETS_TO_CONVERSATION_SECTION_ON_SERVER";
export const ADD_ASSETS_TO_CONVERSATION_SECTION_ON_SERVER_SUCCEDDED = "ADD_ASSETS_TO_CONVERSATION_SECTION_ON_SERVER_SUCCEDDED";
export const ADD_ASSETS_TO_CONVERSATION_SECTION_ON_SERVER_FAILED = "ADD_ASSETS_TO_CONVERSATION_SECTION_ON_SERVER_FAILED";

//link assets
export const CREATE_LINK_ASSET_REQUEST = "CREATE_LINK_ASSET_REQUEST";
export const CREATING_LINK_ASSET_SUCCEEDED = "CREATING_LINK_ASSET_SUCCEEDED";
export const CREATING_LINK_ASSET_FAILED = "CREATING_LINK_ASSET_FAILED";
export const INVALIDATE_LINK_ASSET = "INVALIDATE_LINK_ASSET";

//adoption
export const IDENTIFY_USER_FOR_ADOPTION = "IDENTIFY_USER_FOR_ADOPTION";
export const IDENTIFY_USER_FOR_ADOPTION_SUCCEEDED = "IDENTIFY_USER_FOR_ADOPTION_SUCCEEDED";
export const IDENTIFY_USER_FOR_ADOPTION_FAILED = "IDENTIFY_USER_FOR_ADOPTION_FAILED";

export const TRACKING_EVENT_FOR_ADOPTION = "TRACKING_EVENT_FOR_ADOPTION";
export const TRACKING_EVENT_FOR_ADOPTION_SUCCEEDED = "TRACKING_EVENT_FOR_ADOPTION_SUCCEEDED";
export const TRACKING_EVENT_FOR_ADOPTION_FAILED = "TRACKING_EVENT_FOR_ADOPTION_FAILED";

/**
 * ----------------------------------------------
 * Coaching
 * ----------------------------------------------
*/
// courses

export const FETCH_PUBLIC_COURSES_REQUEST = "FETCH_PUBLIC_COURSES_REQUEST";
export const FETCHING_PUBLIC_COURSES_SUCCEEDED = "FETCHING_PUBLIC_COURSES_SUCCEEDED";
export const FETCHING_PUBLIC_COURSES_FAILED = "FETCHING_PUBLIC_COURSES_FAILED";

export const FETCH_PUBLIC_COURSE_REQUEST = "FETCH_PUBLIC_COURSE_REQUEST";
export const FETCHING_PUBLIC_COURSE_SUCCEEDED = "FETCHING_PUBLIC_COURSE_SUCCEEDED";
export const FETCHING_PUBLIC_COURSE_FAILED = "FETCHING_PUBLIC_COURSE_FAILED";

export const FETCHING_DRAFT_COURSES_REQUEST = "FETCHING_DRAFT_COURSES_REQUEST";
export const FETCHING_DRAFT_COURSES_SUCCEEDED = "FETCHING_DRAFT_COURSES_SUCCEEDED";
export const FETCHING_DRAFT_COURSES_FAILED = "FETCHING_DRAFT_COURSES_FAILED";

export const FETCHING_PUBLISHED_COURSES_REQUEST = "FETCHING_PUBLISHED_COURSES_REQUEST";
export const FETCHING_PUBLISHED_COURSES_SUCCEEDED = "FETCHING_PUBLISHED_COURSES_SUCCEEDED";
export const FETCHING_PUBLISHED_COURSES_FAILED = "FETCHING_PUBLISHED_COURSES_FAILED";

// search courses
export const SEARCH_COURSES_REQUEST = "SEARCH_COURSES_REQUEST";
export const SEARCHING_COURSES_SUCCEEDED = "SEARCHING_COURSES_SUCCEEDED";
export const SEARCHING_COURSES_FAILED = "SEARCHING_COURSES_FAILED";

export const SEARCH_COURSES_SSE_SUBSCRIBE = "SEARCH_COURSES_SSE_SUBSCRIBE";
export const SEARCH_COURSES_SSE_UNSUBSCRIBE = "SEARCH_COURSES_SSE_UNSUBSCRIBE";
export const SEARCH_COURSES_SSE_MESSAGE_RECEIVED = "SEARCH_COURSES_SSE_MESSAGE_RECEIVED";
export const SEARCH_COURSES_SSE_ERROR = "SEARCH_COURSES_SSE_ERROR";
export const INVALIDATE_SSE_SEARCH_RESULTS = "INVALIDATE_SSE_SEARCH_RESULTS";

// create course
export const CREATE_COURSE_REQUEST = "CREATE_COURSE_REQUEST";
export const CREATING_COURSE_SUCCEEDED = "CREATING_COURSE_SUCCEEDED";
export const CREATING_COURSE_FAILED = "CREATING_COURSE_FAILED";

// update course
export const UPDATING_COURSE_REQUEST = "UPDATING_COURSE_REQUEST";
export const UPDATING_COURSE_SUCCEEDED = "UPDATING_COURSE_SUCCEEDED";
export const UPDATING_COURSE_FAILED = "UPDATING_COURSE_FAILED";

// fetch course
export const FETCH_COURSE_REQUEST = "FETCH_COURSE_REQUEST";
export const FETCHING_COURSE_SUCCEEDED = "FETCHING_COURSE_SUCCEEDED";
export const FETCHING_COURSE_FAILED = "FETCHING_COURSE_FAILED";

// fetch draft course 
export const FETCH_DRAFT_COURSE_REQUEST = "FETCH_DRAFT_COURSE_REQUEST";
export const FETCHING_DRAFT_COURSE_SUCCEEDED = "FETCHING_DRAFT_COURSE_SUCCEEDED";
export const FETCHING_DRAFT_COURSE_FAILED = "FETCHING_DRAFT_COURSE_FAILED";
export const INVALIDATE_DRAFT_COURSE = "INVALIDATE_DRAFT_COURSE";

// delete course
export const DELETE_COURSE_REQUEST = "DELETE_COURSE_REQUEST";
export const DELETING_COURSE_SUCCEEDED = "DELETING_COURSE_SUCCEEDED";
export const DELETING_COURSE_FAILED = "DELETING_COURSE_FAILED";

// discard course draft
export const DISCARD_COURSE_DRAFT_REQUEST = "DISCARD_COURSE_DRAFT_REQUEST";
export const DISCARDING_COURSE_DRAFT_SUCCEEDED = "DISCARDING_COURSE_DRAFT_SUCCEEDED";
export const DISCARDING_COURSE_DRAFT_FAILED = "DISCARDING_COURSE_DRAFT_FAILED";

// publish course
export const PUBLISH_COURSE_REQUEST = "PUBLISH_COURSE_REQUEST";
export const PUBLISHING_COURSE_SUCCEEDED = "PUBLISHING_COURSE_SUCCEEDED";
export const PUBLISHING_COURSE_FAILED = "PUBLISHING_COURSE_FAILED";

// invalidate publish course
export const INVALIDATE_PUBLISH_COURSE = "INVALIDATE_PUBLISH_COURSE";

// invalidate courses
export const INVALIDATE_COURSES = "INVALIDATE_COURSES";

// invalidate course creation
export const INVALIDATE_COURSE_CREATION_STATE = "INVALIDATE_COURSE_CREATION_STATE";

// invalidate course update
export const INVALIDATE_COURSE_UPDATE_STATE = "INVALIDATE_COURSE_UPDATE_STATE";

// invalidate course deletion
export const INVALIDATE_COURSE_DELETION_STATE = "INVALIDATE_COURSE_DELETION_STATE";

// invalidate courses search results
export const INVALIDATE_COURSE_SEARCH_RESULTS = "INVALIDATE_COURSE_SEARCH_RESULTS";

export const EDIT_COURSE_REQUEST = "EDIT_COURSE_REQUEST";
export const ADD_ASSET_TO_COURSE = "ADD_ASSET_TO_COURSE";
export const ADD_ASSET_TO_PODCAST = "ADD_ASSET_TO_PODCAST";
export const REMOVE_ENTITY_FROM_COURSE = "REMOVE_ENTITY_FROM_COURSE";
export const REARRANGE_ENTITIES_IN_COURSE = "REARRANGE_ENTITIES_IN_COURSE";

export const UPDATE_COURSE_PROPERTY_REQUEST = "UPDATE_COURSE_PROPERTY_REQUEST";
export const UPDATE_LESSON_PROPERTY_REQUEST = "UPDATE_LESSON_PROPERTY_REQUEST";

// create assessment 
export const CREATE_ASSESSMENT_REQUEST = "CREATE_ASSESSMENT_REQUEST";
export const UPDATE_ASSESSMENT_PROPERTY_REQUEST = "UPDATE_ASSESSMENT_PROPERTY_REQUEST";

export const CREATE_QUESTION_IN_ASSESSMENT_REQUEST = "CREATE_QUESTION_IN_ASSESSMENT_REQUEST";
export const UPDATE_QUESTION_IN_ASSESSMENT_REQUEST = "UPDATE_QUESTION_IN_ASSESSMENT_REQUEST";
export const DELETE_QUESTION_IN_ASSESSMENT_REQUEST = "DELETE_QUESTION_IN_ASSESSMENT_REQUEST";
export const REARRANGE_QUESTIONS_IN_ASSESSMENT_REQUEST = "REARRANGE_QUESTIONS_IN_ASSESSMENT_REQUEST";

export const VALIDATE_COURSE_REQUEST = "VALIDATE_COURSE_REQUEST";
export const UPDATE_VALIDATION_ERRORS_FOR_COURSE = "UPDATE_VALIDATION_ERRORS_FOR_COURSE";

// delete course content
export const DELETE_COURSE_CONTENT = "DELETE_COURSE_CONTENT";

// sections 
export const CREATE_COURSE_SECTION_REQUEST = "CREATE_COURSE_SECTION_REQUEST";
export const UPDATE_COURSE_SECTION_PROPERTY_REQUEST = "UPDATE_COURSE_SECTION_PROPERTY_REQUEST";

//fetch skills
export const FETCHING_SKILLS_REQUEST = "FETCHING_SKILLS_REQUEST";
export const FETCHING_SKILLS_SUCCEEDED = "FETCHING_SKILLS_SUCCEEDED";
export const FETCHING_SKILLS_FAILED = "FETCHING_SKILLS_FAILED";

//search skills
export const SEARCHING_SKILLS_REQUEST = "SEARCHING_SKILLS_REQUEST";
export const SEARCHING_SKILLS_SUCCEEDED = "SEARCHING_SKILLS_SUCCEEDED";
export const SEARCHING_SKILLS_FAILED = "SEARCHING_SKILLS_FAILED";

// create skill
export const CREATING_SKILL_REQUEST = "CREATING_SKILL_REQUEST";
export const CREATING_SKILL_SUCCEEDED = "CREATING_SKILL_SUCCEEDED";
export const CREATING_SKILL_FAILED = "CREATING_SKILL_FAILED";

export const INVALIDATE_CREATE_SKILL = "INVALIDATE_CREATE_SKILL";

// delete skill
export const DELETING_SKILL_REQUEST = "DELETING_SKILL_REQUEST";
export const DELETING_SKILL_SUCCEEDED = "DELETING_SKILL_SUCCEEDED";
export const DELETING_SKILL_FAILED = "DELETING_SKILL_FAILED";

export const INVALIDATE_DELETE_SKILL = "INVALIDATE_DELETE_SKILL";

// update skill
export const UPDATING_SKILL_REQUEST = "UPDATING_SKILL_REQUEST";
export const UPDATING_SKILL_SUCCEEDED = "UPDATING_SKILL_SUCCEEDED";
export const UPDATING_SKILL_FAILED = "UPDATING_SKILL_FAILED";

export const INVALIDATE_UPDATE_SKILL = "INVALIDATE_UPDATE_SKILL";

// update skills preferences
export const UPDATE_SKILLS_PREFERENCES_REQUEST = "UPDATE_SKILLS_PREFERENCES_REQUEST";
export const UPDATING_SKILLS_PREFERENCES_SUCCEEDED = "UPDATING_SKILLS_PREFERENCES_SUCCEEDED";
export const UPDATING_SKILLS_PREFERENCES_FAILED = "UPDATING_SKILLS_PREFERENCES_FAILED";

// fetch preferences skills
export const FETCH_PREFERENCES_SKILLS_REQUEST = "FETCH_PREFERENCES_SKILLS_REQUEST";
export const FETCHING_PREFERENCES_SKILLS_SUCCEEDED = "FETCHING_PREFERENCES_SKILLS_SUCCEEDED";
export const FETCHING_PREFERENCES_SKILLS_FAILED = "FETCHING_PREFERENCES_SKILLS_FAILED";

// invalidate skills
export const INVALIDATE_SKILLS = "INVALIDATE_SKILLS";

// fetch assessment configurations
export const FETCH_ASSESSMENT_CONFIGURATIONS_REQUEST = "FETCH_ASSESSMENT_CONFIGURATIONS_REQUEST";
export const FETCHING_ASSESSMENT_CONFIGURATIONS_SUCCEEDED = "FETCHING_ASSESSMENT_CONFIGURATIONS_SUCCEEDED";
export const FETCHING_ASSESSMENT_CONFIGURATIONS_FAILED = "FETCHING_ASSESSMENT_CONFIGURATIONS_FAILED";

//Fetch lesson for course
export const FETCH_LESSON_FOR_COURSE_REQUEST = "FETCH_LESSON_FOR_COURSE_REQUEST";
export const FETCHING_LESSON_FOR_COURSE_SUCCEEDED = "FETCHING_LESSON_FOR_COURSE_SUCCEEDED";
export const FETCHING_LESSON_FOR_COURSE_FAILED = "FETCHING_LESSON_FOR_COURSE_FAILED";

export const FETCH_LESSON_PREVIEW_FOR_COURSE_REQUEST = "FETCH_LESSON_PREVIEW_FOR_COURSE_REQUEST";
export const FETCHING_LESSON_PREVIEW_FOR_COURSE_SUCCEEDED = "FETCHING_LESSON_PREVIEW_FOR_COURSE_SUCCEEDED";
export const FETCHING_LESSON_PREVIEW_FOR_COURSE_FAILED = "FETCHING_LESSON_PREVIEW_FOR_COURSE_FAILED";

//learners
export const ADD_LEARNER_TO_COURSE_REQUEST = "ADD_LEARNER_TO_COURSE_REQUEST";
export const ADDING_LEARNER_TO_COURSE_SUCCEEDED = "ADDING_LEARNER_TO_COURSE_SUCCEEDED";
export const ADDING_LEARNER_TO_COURSE_FAILED = "ADDING_LEARNER_TO_COURSE_FAILED";

export const FETCH_COURSE_LEARNERS_REQUEST = "FETCH_COURSE_LEARNERS_REQUEST";
export const FETCHING_COURSE_LEARNERS_SUCCEEDED = "FETCHING_COURSE_LEARNERS_SUCCEEDED";
export const FETCHING_COURSE_LEARNERS_FAILED = "FETCHING_COURSE_LEARNERS_FAILED";

export const FETCH_LEARNERS_REQUEST = "FETCH_LEARNERS_REQUEST";
export const FETCHING_LEARNERS_SUCCEEDED = "FETCHING_LEARNERS_SUCCEEDED";
export const FETCHING_LEARNERS_FAILED = "FETCHING_LEARNERS_FAILED";

export const SEARCH_LEARNERS_REQUEST = "SEARCH_LEARNERS_REQUEST";
export const SEARCHING_LEARNERS_SUCCEEDED = "SEARCHING_LEARNERS_SUCCEEDED";
export const SEARCHING_LEARNERS_FAILED = "SEARCHING_LEARNERS_FAILED";

export const FETCHING_MY_COURSES_REQUEST = "FETCHING_MY_COURSES_REQUEST";
export const FETCHING_MY_COURSES_SUCCEEDED = "FETCHING_MY_COURSES_SUCCEEDED";
export const FETCHING_MY_COURSES_FAILED = "FETCHING_MY_COURSES_FAILED";

export const INVALIDATE_ADD_LEARNERS_STATE = "INVALIDATE_ADD_LEARNERS_STATE";
export const INVALIDATE_LEARNERS_STATE = "INVALIDATE_LEARNERS_STATE";
export const INVALIDATE_LEARNER_SEARCH_RESULTS = "INVALIDATE_LEARNER_SEARCH_RESULTS";

//Learner records for course
export const FETCH_LEARNING_RECORD_COURSE_REQUEST = "FETCH_LEARNING_RECORD_COURSE_REQUEST";
export const FETCHING_LEARNING_RECORD_COURSE_SUCCEEDED = "FETCHING_LEARNING_RECORD_COURSE_SUCCEEDED";
export const FETCHING_LEARNING_RECORD_COURSE_FAILED = "FETCHING_LEARNING_RECORD_COURSE_FAILED";

//Learner records for simulation
export const FETCH_LEARNING_RECORD_SIMULATION_REQUEST = "FETCH_LEARNING_RECORD_SIMULATION_REQUEST";
export const FETCHING_LEARNING_RECORD_SIMULATION_SUCCEEDED = "FETCHING_LEARNING_RECORD_SIMULATION_SUCCEEDED";
export const FETCHING_LEARNING_RECORD_SIMULATION_FAILED = "FETCHING_LEARNING_RECORD_SIMULATION_FAILED";

// generate transcripts for call recording
export const GENERATE_TRANSCRIPTS_FOR_CALL_RECORDING_REQUEST = "GENERATE_TRANSCRIPTS_FOR_CALL_RECORDING_REQUEST";
export const GENERATING_TRANSCRIPTS_FOR_CALL_RECORDING_SUCCEEDED = "GENERATING_TRANSCRIPTS_FOR_CALL_RECORDING_SUCCEEDED";
export const GENERATING_TRANSCRIPTS_FOR_CALL_RECORDING_FAILED = "GENERATING_TRANSCRIPTS_FOR_CALL_RECORDING_FAILED";

// fetch call recordings 
export const FETCH_CALL_RECORDINGS_REQUEST = "FETCH_CALL_RECORDINGS_REQUEST";
export const FETCHING_CALL_RECORDINGS_SUCCEEDED = "FETCHING_CALL_RECORDINGS_SUCCEEDED";
export const FETCHING_CALL_RECORDINGS_FAILED = "FETCHING_CALL_RECORDINGS_FAILED";

//fetch call recording
export const FETCH_CALL_RECORDING_REQUEST = "FETCH_CALL_RECORDING_REQUEST";
export const FETCHING_CALL_RECORDING_SUCCEEDED = "FETCHING_CALL_RECORDING_SUCCEEDED";
export const FETCHING_CALL_RECORDING_FAILED = "FETCHING_CALL_RECORDING_FAILED";

// delete call recording
export const DELETE_CALL_RECORDING_REQUEST = "DELETE_CALL_RECORDING_REQUEST";
export const DELETING_CALL_RECORDING_SUCCEEDED = "DELETING_CALL_RECORDING_SUCCEEDED";
export const DELETING_CALL_RECORDING_FAILED = "DELETING_CALL_RECORDING_FAILED";

//web socket
export const WS_CALL_RECORDING_PROFILE_GENERATION_COMPLETED = "WS_CALL_RECORDING_PROFILE_GENERATION_COMPLETED";
export const SYNC_CALL_RECORDING_PROFILE_PROCESSING_STATE_REQUEST = "SYNC_CALL_RECORDING_PROFILE_PROCESSING_STATE_REQUEST";
export const SYNCING_CALL_RECORDING_PROFILE_PROCESSING_STATE_SUCCEEDED = "SYNCING_CALL_RECORDING_PROFILE_PROCESSING_STATE_SUCCEEDED";
export const SYNCING_CALL_RECORDING_PROFILE_PROCESSING_STATE_FAILED = "SYNCING_CALL_RECORDING_PROFILE_PROCESSING_STATE_FAILED";


//Learner records for podcast
export const FETCH_LEARNING_RECORD_PODCAST_REQUEST = "FETCH_LEARNING_RECORD_PODCAST_REQUEST";
export const FETCHING_LEARNING_RECORD_PODCAST_SUCCEEDED = "FETCHING_LEARNING_RECORD_PODCAST_SUCCEEDED";
export const FETCHING_LEARNING_RECORD_PODCAST_FAILED = "FETCHING_LEARNING_RECORD_PODCAST_FAILED";


//learner start course
export const START_COURSE_REQUEST = "START_COURSE_REQUEST";
export const STARTING_COURSE_SUCCEEDED = "STARTING_COURSE_SUCCEEDED";
export const STARTING_COURSE_FAILED = "STARTING_COURSE_FAILED";
export const INVALIDATE_START_COURSE = "INVALIDATE_START_COURSE";

export const ENROLL_COURSE_REQUEST = "ENROLL_COURSE_REQUEST";
export const ENROLLING_COURSE_SUCCEEDED = "ENROLLING_COURSE_SUCCEEDED";
export const ENROLLING_COURSE_FAILED = "ENROLLING_COURSE_FAILED";

export const UPDATE_COURSE_SESSION_REQUEST = "UPDATE_COURSE_SESSION_REQUEST";
export const UPDATING_COURSE_SESSION_SUCCEEDED = "UPDATING_COURSE_SESSION_SUCCEEDED";
export const UPDATING_COURSE_SESSION_FAILED = "UPDATING_COURSE_SESSION_FAILED";

export const COMPLETE_COURSE_REQUEST = "COMPLETE_COURSE_REQUEST";
export const COMPLETING_COURSE_SUCCEEDED = "COMPLETING_COURSE_SUCCEEDED";
export const COMPLETING_COURSE_FAILED = "COMPLETING_COURSE_FAILED";
export const INVALIDATE_COMPLETE_COURSE = "INVALIDATE_COMPLETE_COURSE";

//learner reatake coruse
export const RETAKE_COURSE_REQUEST = "RETAKE_COURSE_REQUEST";
export const RETAKING_COURSE_SUCCEEDED = "RETAKING_COURSE_SUCCEEDED";
export const RETAKING_COURSE_FAILED = "RETAKING_COURSE_FAILED";
export const INVALIDATE_RETAKE_COURSE = "INVALIDATE_RETAKE_COURSE";

// learning record lesson
export const FETCH_LESSON_FOR_LEARNING_RECORD_REQUEST = "FETCH_LESSON_FOR_LEARNING_RECORD_REQUEST";
export const FETCHING_LESSON_FOR_LEARNING_RECORD_SUCCEEDED = "FETCHING_LESSON_FOR_LEARNING_RECORD_SUCCEEDED";
export const FETCHING_LESSON_FOR_LEARNING_RECORD_FAILED = "FETCHING_LESSON_FOR_LEARNING_RECORD_FAILED";

export const FETCH_LESSON_PREVIEW_FOR_LEARNING_RECORD_REQUEST = "FETCH_LESSON_PREVIEW_FOR_LEARNING_RECORD_REQUEST";
export const FETCHING_LESSON_PREVIEW_FOR_LEARNING_RECORD_SUCCEEDED = "FETCHING_LESSON_PREVIEW_FOR_LEARNING_RECORD_SUCCEEDED";
export const FETCHING_LESSON_PREVIEW_FOR_LEARNING_RECORD_FAILED = "FETCHING_LESSON_PREVIEW_FOR_LEARNING_RECORD_FAILED";

//course content analytics
export const CREATE_LESSON_ANALYTICS_EVENT = "CREATE_LESSON_ANALYTICS_EVENT";
export const CREATING_LESSON_ANALYTICS_EVENT_SUCCEEDED = "CREATING_LESSON_ANALYTICS_EVENT_SUCCEEDED";
export const CREATING_LESSON_ANALYTICS_EVENT_FAILED = "CREATING_LESSON_ANALYTICS_EVENT_FAILED";

export const RECORD_LESSON_ANALYTICS_EVENT = "RECORD_LESSON_ANALYTICS_EVENT";
export const RECORDING_LESSON_ANALYTICS_EVENT_SUCCEEDED = "RECORDING_LESSON_ANALYTICS_EVENT_SUCCEEDED";
export const RECORDING_LESSON_ANALYTICS_EVENT_FAILED = "RECORDING_LESSON_ANALYTICS_EVENT_FAILED";

export const CREATE_COURSE_CONTENT_SESSION_REQUEST = "CREATE_COURSE_CONTENT_SESSION_REQUEST";
export const CREATING_COURSE_CONTENT_SESSION_SUCCEEDED = "CREATING_COURSE_CONTENT_SESSION_SUCCEEDED";
export const CREATING_COURSE_CONTENT_SESSION_FAILED = "CREATING_COURSE_CONTENT_SESSION_FAILED";

export const FETCH_COURSE_CONTENT_SESSION_REQUEST = "FETCH_COURSE_CONTENT_SESSION_REQUEST";
export const FETCHING_COURSE_CONTENT_SESSION_SUCCEEDED = "FETCHING_COURSE_CONTENT_SESSION_SUCCEEDED";
export const FETCHING_COURSE_CONTENT_SESSION_FAILED = "FETCHING_COURSE_CONTENT_SESSION_FAILED";

export const UPDATE_COURSE_CONTENT_SESSION_REQUEST = "UPDATE_COURSE_CONTENT_SESSION_REQUEST";
export const UPDATING_COURSE_CONTENT_SESSION_SUCCEEDED = "UPDATING_COURSE_CONTENT_SESSION_SUCCEEDED";
export const UPDATING_COURSE_CONTENT_SESSION_FAILED = "UPDATING_COURSE_CONTENT_SESSION_FAILED";

export const FETCH_ASSESSMENT_REPORT_REQUEST = "FETCH_ASSESSMENT_REPORT_REQUEST";
export const FETCHING_ASSESSMENT_REPORT_SUCCEEDED = "FETCHING_ASSESSMENT_REPORT_SUCCEEDED";
export const FETCHING_ASSESSMENT_REPORT_FAILED = "FETCHING_ASSESSMENT_REPORT_FAILED";

export const INVALIDATE_COURSE_CONTENT_SESSION = "INVALIDATE_COURSE_CONTENT_SESSION";

export const COMPLETE_COURSE_CONTENT_SESSION_REQUEST = "COMPLETE_COURSE_CONTENT_SESSION_REQUEST";
export const COMPLETING_COURSE_CONTENT_SESSION_SUCCEEDED = "COMPLETING_COURSE_CONTENT_SESSION_SUCCEEDED";
export const COMPLETING_COURSE_CONTENT_SESSION_FAILED = "COMPLETING_COURSE_CONTENT_SESSION_FAILED";

export const RECORD_ANSWER_FOR_QUESTION_REQUEST = "RECORD_ANSWER_FOR_QUESTION_REQUEST";

export const RECORD_QUESTION_SESSION_REQUEST = "RECORD_QUESTION_SESSION_REQUEST";
export const RECORDING_QUESTION_SESSION_SUCCEEDED = "RECORDING_QUESTION_SESSION_SUCCEEDED";
export const RECORDING_QUESTION_SESSION_FAILED = "RECORDING_QUESTION_SESSION_FAILED";

export const UPDATE_LESSON_PROGRESS_REQUEST = "UPDATE_LESSON_PROGRESS_REQUEST";

//course attempts 
export const FETCH_ATTEMPTS_FOR_COURSE_REQUEST = "FETCH_ATTEMPTS_FOR_COURSE_REQUEST";
export const FETCHING_ATTEMPTS_FOR_COURSE_SUCCEEDED = "FETCHING_ATTEMPTS_FOR_COURSE_SUCCEEDED";
export const FETCHING_ATTEMPTS_FOR_COURSE_FAILED = "FETCHING_ATTEMPTS_FOR_COURSE_FAILED";

// fetch learner's records
export const FETCH_COURSE_LEARNING_REQUEST = "FETCH_COURSE_LEARNING_REQUEST";
export const FETCHING_COURSE_LEARNING_RECORD_SUCCEEDED = "FETCHING_COURSE_LEARNING_RECORD_SUCCEEDED";
export const FETCHING_COURSE_LEARNING_RECORD_FAILED = "FETCHING_COURSE_LEARNING_RECORD_FAILED";

// fetch learner's assessment report
export const FETCH_LEARNERS_ASSESSMENT_REPORT_REQUEST = "FETCH_LEARNERS_ASSESSMENT_REPORT_REQUEST";
export const FETCHING_LEARNERS_ASSESSMENT_REPORT_SUCCEEDED = "FETCHING_LEARNERS_ASSESSMENT_REPORT_SUCCEEDED";
export const FETCHING_LEARNERS_ASSESSMENT_REPORT_FAILED = "FETCHING_LEARNERS_ASSESSMENT_REPORT_FAILED";

export const INVALIDATE_LEARNERS_ASSESSMENT_REPORT = "INVALIDATE_LEARNERS_ASSESSMENT_REPORT";

// REPORTS
//CREATIONS
export const FETCH_CREATIONS_DASHBOARD_REPORT_REQUEST = "FETCH_CREATIONS_DASHBOARD_REPORT_REQUEST";
export const FETCHING_CREATIONS_DASHBOARD_REPORT_SUCCEEDED = "FETCHING_CREATIONS_DASHBOARD_REPORT_SUCCEEDED";
export const FETCHING_CREATIONS_DASHBOARD_REPORT_FAILED = "FETCHING_CREATIONS_DASHBOARD_REPORT_FAILED";

export const FETCH_CREATIONS_LEARNERS_REPORT_REQUEST = "FETCH_CREATIONS_LEARNERS_REPORT_REQUEST";
export const FETCHING_CREATIONS_LEARNERS_REPORT_SUCCEEDED = "FETCHING_CREATIONS_LEARNERS_REPORT_SUCCEEDED";
export const FETCHING_CREATIONS_LEARNERS_REPORT_FAILED = "FETCHING_CREATIONS_LEARNERS_REPORT_FAILED";

export const FETCH_CREATIONS_TOP_LEARNINGS_REPORT_REQUEST = "FETCH_CREATIONS_TOP_LEARNINGS_REPORT_REQUEST";
export const FETCHING_CREATIONS_TOP_LEARNINGS_REPORT_SUCCEEDED = "FETCHING_CREATIONS_TOP_LEARNINGS_REPORT_SUCCEEDED";
export const FETCHING_CREATIONS_TOP_LEARNINGS_REPORT_FAILED = "FETCHING_CREATIONS_TOP_LEARNINGS_REPORT_FAILED";

export const FETCH_CREATIONS_LEARNINGS_INSIGHTS_REPORT_REQUEST = "FETCH_CREATIONS_LEARNINGS_INSIGHTS_REPORT_REQUEST";
export const FETCHING_CREATIONS_LEARNINGS_INSIGHTS_REPORT_SUCCEEDED = "FETCHING_CREATIONS_LEARNINGS_INSIGHTS_REPORT_SUCCEEDED";
export const FETCHING_CREATIONS_LEARNINGS_INSIGHTS_REPORT_FAILED = "FETCHING_CREATIONS_LEARNINGS_INSIGHTS_REPORT_FAILED";


// LEARNINGS
export const FETCH_LEARNINGS_DASHBOARD_REPORT_REQUEST = "FETCH_LEARNINGS_DASHBOARD_REPORT_REQUEST";
export const FETCHING_LEARNINGS_DASHBOARD_REPORT_SUCCEEDED = "FETCHING_LEARNINGS_DASHBOARD_REPORT_SUCCEEDED";
export const FETCHING_LEARNINGS_DASHBOARD_REPORT_FAILED = "FETCHING_LEARNINGS_DASHBOARD_REPORT_FAILED";

export const FETCH_LEARNINGS_LEADERBOARD_REPORT_REQUEST = "FETCH_LEARNINGS_LEADERBOARD_REPORT_REQUEST";
export const FETCHING_LEARNINGS_LEADERBOARD_REPORT_SUCCEEDED = "FETCHING_LEARNINGS_LEADERBOARD_REPORT_SUCCEEDED";
export const FETCHING_LEARNINGS_LEADERBOARD_REPORT_FAILED = "FETCHING_LEARNINGS_LEADERBOARD_REPORT_FAILED";

export const FETCH_LEARNINGS_SKILLS_REPORT_REQUEST = "FETCH_LEARNINGS_SKILLS_REPORT_REQUEST";
export const FETCHING_LEARNINGS_SKILLS_REPORT_SUCCEEDED = "FETCHING_LEARNINGS_SKILLS_REPORT_SUCCEEDED";
export const FETCHING_LEARNINGS_SKILLS_REPORT_FAILED = "FETCHING_LEARNINGS_SKILLS_REPORT_FAILED";

export const FETCH_LEARNINGS_TIMELINE_REPORT_REQUEST = "FETCH_LEARNINGS_TIMELINE_REPORT_REQUEST";
export const FETCHING_LEARNINGS_TIMELINE_REPORT_SUCCEEDED = "FETCHING_LEARNINGS_TIMELINE_REPORT_SUCCEEDED";
export const FETCHING_LEARNINGS_TIMELINE_REPORT_FAILED = "FETCHING_LEARNINGS_TIMELINE_REPORT_FAILED";

export const FETCH_LEARNINGS_POPULAR_REPORT_REQUEST = "FETCH_LEARNINGS_POPULAR_REPORT_REQUEST";
export const FETCHING_LEARNINGS_POPULAR_REPORT_SUCCEEDED = "FETCHING_LEARNINGS_POPULAR_REPORT_SUCCEEDED";
export const FETCHING_LEARNINGS_POPULAR_REPORT_FAILED = "FETCHING_LEARNINGS_POPULAR_REPORT_FAILED";

export const FETCH_LEARNINGS_INSIGHTS_REPORT_REQUEST = "FETCH_LEARNINGS_INSIGHTS_REPORT_REQUEST";
export const FETCHING_LEARNINGS_INSIGHTS_REPORT_SUCCEEDED = "FETCHING_LEARNINGS_INSIGHTS_REPORT_SUCCEEDED";
export const FETCHING_LEARNINGS_INSIGHTS_REPORT_FAILED = "FETCHING_LEARNINGS_INSIGHTS_REPORT_FAILED";


// TEAMS
export const FETCH_TEAMS_LEARNINGS_REPORT_REQUEST = "FETCH_TEAMS_LEARNINGS_REPORT_REQUEST";
export const FETCHING_TEAMS_LEARNINGS_REPORT_SUCCEEDED = "FETCHING_TEAMS_LEARNINGS_REPORT_SUCCEEDED";
export const FETCHING_TEAMS_LEARNINGS_REPORT_FAILED = "FETCHING_TEAMS_LEARNINGS_REPORT_FAILED";

export const FETCH_TEAMS_MOST_ENROLLED_LEARNINGS_REPORT_REQUEST = "FETCH_TEAMS_MOST_ENROLLED_LEARNINGS_REPORT_REQUEST";
export const FETCHING_TEAMS_MOST_ENROLLED_LEARNINGS_REPORT_SUCCEEDED = "FETCHING_TEAMS_MOST_ENROLLED_LEARNINGS_REPORT_SUCCEEDED";
export const FETCHING_TEAMS_MOST_ENROLLED_LEARNINGS_REPORT_FAILED = "FETCHING_TEAMS_MOST_ENROLLED_LEARNINGS_REPORT_FAILED";

export const FETCH_TEAMS_LEARNERS_REPORT_REQUEST = "FETCH_TEAMS_LEARNERS_REPORT_REQUEST";
export const FETCHING_TEAMS_LEARNERS_REPORT_SUCCEEDED = "FETCHING_TEAMS_LEARNERS_REPORT_SUCCEEDED";
export const FETCHING_TEAMS_LEARNERS_REPORT_FAILED = "FETCHING_TEAMS_LEARNERS_REPORT_FAILED";

export const FETCH_TEAMS_LEADERBOARD_REPORT_REQUEST = "FETCH_TEAMS_LEADERBOARD_REPORT_REQUEST";
export const FETCHING_TEAMS_LEADERBOARD_REPORT_SUCCEEDED = "FETCHING_TEAMS_LEADERBOARD_REPORT_SUCCEEDED";
export const FETCHING_TEAMS_LEADERBOARD_REPORT_FAILED = "FETCHING_TEAMS_LEADERBOARD_REPORT_FAILED";

export const FETCH_TEAMS_DASHBOARD_REPORT_REQUEST = "FETCH_TEAMS_DASHBOARD_REPORT_REQUEST";
export const FETCHING_TEAMS_DASHBOARD_REPORT_SUCCEEDED = "FETCHING_TEAMS_DASHBOARD_REPORT_SUCCEEDED";
export const FETCHING_TEAMS_DASHBOARD_REPORT_FAILED = "FETCHING_TEAMS_DASHBOARD_REPORT_FAILED";

export const FETCH_SKILLS_REPORT_REQUEST = "FETCH_SKILLS_REPORT_REQUEST";
export const FETCHING_SKILLS_REPORT_SUCCEEDED = "FETCHING_SKILLS_REPORT_SUCCEEDED";
export const FETCHING_SKILLS_REPORT_FAILED = "FETCHING_SKILLS_REPORT_FAILED";


//Generate Question
export const GENERATE_QUESTIONS_REQUEST = "GENERATE_QUESTIONS_REQUEST";
export const GENERATING_QUESTIONS_SUCCEEDED = "GENERATING_QUESTIONS_SUCCEEDED";
export const GENERATING_QUESTIONS_FAILED = "GENERATING_QUESTIONS_FAILED";
export const INVALIDATE_GENERATE_QUESTIONS = "INVALIDATE_GENERATE_QUESTIONS";
export const WS_GENERATE_QUESTION_SYNC = "WS_GENERATE_QUESTION_SYNC";

/**
 * ----------------------------------------------
 * End of Coaching
 * ----------------------------------------------
*/

/**
 * ----------------------------------------------
 * Simulation
 * ----------------------------------------------
 */
export const CREATE_SIMULATION_REQUEST = "CREATE_SIMULATION_REQUEST";
export const CREATING_SIMULATION_SUCCEEDED = "CREATING_SIMULATION_SUCCEEDED";
export const CREATING_SIMULATION_FAILED = "CREATING_SIMULATION_FAILED";
export const INVALIDATE_SIMULATION_CREATION_STATE = "INVALIDATE_SIMULATION_CREATION_STATE";

// fetch draft simulation 
export const FETCH_DRAFT_SIMULATION_REQUEST = "FETCH_DRAFT_SIMULATION_REQUEST";
export const FETCHING_DRAFT_SIMULATION_SUCCEEDED = "FETCHING_DRAFT_SIMULATION_SUCCEEDED";
export const FETCHING_DRAFT_SIMULATION_FAILED = "FETCHING_DRAFT_SIMULATION_FAILED";

// update simulation
export const UPDATING_SIMULATION_REQUEST = "UPDATING_SIMULATION_REQUEST";
export const UPDATING_SIMULATION_SUCCEEDED = "UPDATING_SIMULATION_SUCCEEDED";
export const UPDATING_SIMULATION_FAILED = "UPDATING_SIMULATION_FAILED";
// invalidate course update
export const INVALIDATE_SIMULATION_UPDATE_STATE = "INVALIDATE_SIMULATION_UPDATE_STATE";

// validate simulation
export const VALIDATE_SIMULATION_REQUEST = "VALIDATE_SIMULATION_REQUEST";
export const UPDATE_VALIDATION_ERRORS_FOR_SIMULATION = "UPDATE_VALIDATION_ERRORS_FOR_SIMULATION";

// publish simulation
export const PUBLISHING_SIMULATION_REQUEST = "PUBLISHING_SIMULATION_REQUEST";
export const PUBLISHING_SIMULATION_SUCCEEDED = "PUBLISHING_SIMULATION_SUCCEEDED";
export const PUBLISHING_SIMULATION_FAILED = "PUBLISHING_SIMULATION_FAILED";

export const EDIT_SIMULATION_REQUEST = "EDIT_SIMULATION_REQUEST";
export const UPDATE_SIMULATION_PROPERTY_REQUEST = "UPDATE_SIMULATION_PROPERTY_REQUEST";

// Simulation editor
export const CREATING_SIMULATION_EDITOR_CHAT_REQUEST = "CREATING_SIMULATION_EDITOR_CHAT_REQUEST";
export const CREATING_SIMULATION_EDITOR_CHAT_SUCCEEDED = "CREATING_SIMULATION_EDITOR_CHAT_SUCCEEDED";
export const CREATING_SIMULATION_EDITOR_CHAT_FAILED = "CREATING_SIMULATION_EDITOR_CHAT_FAILED";

export const GENERATING_SUMMARY_FOR_SIMULATION_REQUEST = "GENERATING_SUMMARY_FOR_SIMULATION_REQUEST";
export const GENERATING_SUMMARY_FOR_SIMULATION_SUCCEEDED = "GENERATING_SUMMARY_FOR_SIMULATION_SUCCEEDED";
export const GENERATING_SUMMARY_FOR_SIMULATION_FAILED = "GENERATING_SUMMARY_FOR_SIMULATION_FAILED";
export const INAVLIDATE_GENERATE_SUMMARY_FOR_SIMULATION = "INAVLIDATE_GENERATE_SUMMARY_FOR_SIMULATION";

// Fetch Personalities
export const FETCHING_PERSONALITIES_FOR_SIMULATION_REQUEST = "FETCHING_PERSONALITIES_FOR_SIMULATION_REQUEST";
export const FETCHING_PERSONALITIES_FOR_SIMULATION_SUCCEEDED = "FETCHING_PERSONALITIES_FOR_SIMULATION_SUCCEEDED";
export const FETCHING_PERSONALITIES_FOR_SIMULATION_FAILED = "FETCHING_PERSONALITIES_FOR_SIMULATION_FAILED";

// Fetch Voices
export const FETCHING_VOICES_FOR_SIMULATION_REQUEST = "FETCHING_VOICES_FOR_SIMULATION_REQUEST";
export const FETCHING_VOICES_FOR_SIMULATION_SUCCEEDED = "FETCHING_VOICES_FOR_SIMULATION_SUCCEEDED";
export const FETCHING_VOICES_FOR_SIMULATION_FAILED = "FETCHING_VOICES_FOR_SIMULATION_FAILED";

// Shuffle simulation configuration
export const SHUFFLING_PERSONA_FOR_SIMULATION_REQUEST = "SHUFFLING_PERSONA_FOR_SIMULATION_REQUEST";
export const SHUFFLING_PERSONA_FOR_SIMULATION_SUCCEEDED = "SHUFFLING_PERSONA_FOR_SIMULATION_SUCCEEDED";
export const SHUFFLING_PERSONA_FOR_SIMULATION_FAILED = "SHUFFLING_PERSONA_FOR_SIMULATION_FAILED";
export const INVALIDATE_SHUFFLE_PERSONA_STATE = "INVALIDATE_SHUFFLE_PERSONA_STATE";

export const SHUFFLING_ORGANIZATION_FOR_SIMULATION_REQUEST = "SHUFFLING_ORGANIZATION_FOR_SIMULATION_REQUEST";
export const SHUFFLING_ORGANIZATION_FOR_SIMULATION_SUCCEEDED = "SHUFFLING_ORGANIZATION_FOR_SIMULATION_SUCCEEDED";
export const SHUFFLING_ORGANIZATION_FOR_SIMULATION_FAILED = "SHUFFLING_ORGANIZATION_FOR_SIMULATION_FAILED";
export const INVALIDATE_SHUFFLE_ORGANIZATION_STATE = "INVALIDATE_SHUFFLE_ORGANIZATION_STATE";

export const SHUFFLING_OBJECTIVES_FOR_SIMULATION_REQUEST = "SHUFFLING_OBJECTIVES_FOR_SIMULATION_REQUEST";
export const SHUFFLING_OBJECTIVES_FOR_SIMULATION_SUCCEEDED = "SHUFFLING_OBJECTIVES_FOR_SIMULATION_SUCCEEDED";
export const SHUFFLING_OBJECTIVES_FOR_SIMULATION_FAILED = "SHUFFLING_OBJECTIVES_FOR_SIMULATION_FAILED";
export const INVALIDATE_SHUFFLE_OBJECTIVES_STATE = "INVALIDATE_SHUFFLE_OBJECTIVES_STATE";

// Clear simulation configration
export const CLEAR_ORGANIZATION_FOR_SIMULATION = "CLEAR_ORGANIZATION_FOR_SIMULATION";
export const CLEAR_PERSONA_FOR_SIMULATION = "CLEAR_PERSONA_FOR_SIMULATION";
export const CLEAR_OBJECTIVES_FOR_SIMULATION = "CLEAR_OBJECTIVES_FOR_SIMULATION";

// delete simulation
export const DELETE_SIMULATION_REQUEST = "DELETE_SIMULATION_REQUEST";
export const DELETING_SIMULATION_SUCCEEDED = "DELETING_SIMULATION_SUCCEEDED";
export const DELETING_SIMULATION_FAILED = "DELETING_SIMULATION_FAILED";
export const INVALIDATE_SIMULATION_DELETION_STATE = "INVALIDATE_SIMULATION_DELETION_STATE";

// discard simulation draft
export const DISCARD_SIMULATION_DRAFT_REQUEST = "DISCARD_SIMULATION_DRAFT_REQUEST";
export const DISCARDING_SIMULATION_DRAFT_SUCCEEDED = "DISCARDING_SIMULATION_DRAFT_SUCCEEDED";
export const DISCARDING_SIMULATION_DRAFT_FAILED = "DISCARDING_SIMULATION_DRAFT_FAILED";


//learner start simulation
export const START_SIMULATION = "START_SIMULATION";
export const STARTING_SIMULATION_SUCCEEDED = "STARTING_SIMULATION_SUCCEEDED";
export const STARTING_SIMULATION_FAILED = "STARTING_SIMULATION_FAILED";
export const INVALIDATE_START_SIMULATION = "INVALIDATE_START_SIMULATION";

export const RETAKE_SIMULATION_REQUEST = "RETAKE_SIMULATION_REQUEST";
export const RETAKING_SIMULATION_SUCCEEDED = "RETAKING_SIMULATION_SUCCEEDED";
export const RETAKING_SIMULATION_FAILED = "RETAKING_SIMULATION_FAILED";
export const INVALIDATE_RETAKE_SIMULATION = "INVALIDATE_RETAKE_SIMULATION";

export const COMPLETE_SIMULATION = "COMPLETE_SIMULATION";
export const COMPLETING_SIMULATION_SUCCEEDED = "COMPLETING_SIMULATION_SUCCEEDED";
export const COMPLETING_SIMULATION_FAILED = "COMPLETING_SIMULATION_FAILED";
export const INVALIDATE_COMPLETE_SIMULATION = "INVALIDATE_COMPLETE_SIMULATION";

export const RESTART_SIMULATION = "RESTART_SIMULATION";
export const RESTARTING_SIMULATION_SUCCEEDED = "RESTARTING_SIMULATION_SUCCEEDED";
export const RESTARTING_SIMULATION_FAILED = "RESTARTING_SIMULATION_FAILED";
export const INVALIDATE_RESTART_SIMULATION = "INVALIDATE_RESTART_SIMULATION";

export const WS_SIMULATION_EVALUATION_COMPLETED = "WS_SIMULATION_EVALUATION_COMPLETED";

// fetch simulation report
export const FETCH_SIMULATION_REPORT_REQUEST = "FETCH_SIMULATION_REPORT_REQUEST";
export const FETCHING_SIMULATION_REPORT_SUCCEEDED = "FETCHING_SIMULATION_REPORT_SUCCEEDED";
export const FETCHING_SIMULATION_REPORT_FAILED = "FETCHING_SIMULATION_REPORT_FAILED";

export const FETCH_TRANSCRIPTS_FOR_LEARNING_SIMULATION_REQUEST = "FETCH_TRANSCRIPTS_FOR_LEARNING_SIMULATION_REQUEST";
export const FETCHING_TRANSCRIPTS_FOR_LEARNING_SIMULATION_SUCCEEDED = "FETCHING_TRANSCRIPTS_FOR_LEARNING_SIMULATION_SUCCEEDED";
export const FETCHING_TRANSCRIPTS_FOR_LEARNING_SIMULATION_FAILED = "FETCHING_TRANSCRIPTS_FOR_LEARNING_SIMULATION_FAILED";

export const INVALIDATE_SIMULATION_REPORT = "INVALIDATE_SIMULATION_REPORT";

// attempt simulation

export const FETCH_ATTEMPTS_FOR_SIMULATION_REQUEST = "FETCH_ATTEMPTS_FOR_SIMULATION_REQUEST";
export const FETCHING_ATTEMPTS_FOR_SIMULATION_SUCCEEDED = "FETCHING_ATTEMPTS_FOR_SIMULATION_SUCCEEDED";
export const FETCHING_ATTEMPTS_FOR_SIMULATION_FAILED = "FETCHING_ATTEMPTS_FOR_SIMULATION_FAILED";


export const FETCH_LEARNER_REPORT = "FETCH_LEARNER_REPORT";
export const FETCHING_LEARNER_REPORT_SUCCEEDED = "FETCHING_LEARNER_REPORT_SUCCEEDED";
export const FETCHING_LEARNER_REPORT_FAILED = "FETCHING_LEARNER_REPORT_FAILED";

export const FETCH_TRANSCRIPTS_FOR_SIMULATION_REQUEST = "FETCH_TRANSCRIPTS_FOR_SIMULATION_REQUEST";
export const FETCHING_TRANSCRIPTS_FOR_SIMULATION_SUCCEEDED = "FETCHING_TRANSCRIPTS_FOR_SIMULATION_SUCCEEDED";
export const FETCHING_TRANSCRIPTS_FOR_SIMULATION_FAILED = "FETCHING_TRANSCRIPTS_FOR_SIMULATION_FAILED";

//learner start podcast
export const START_PODCAST_REQUEST = "START_PODCAST_REQUEST";
export const STARTING_PODCAST_SUCCEEDED = "STARTING_PODCAST_SUCCEEDED";
export const STARTING_PODCAST_FAILED = "STARTING_PODCAST_FAILED";
export const INVALIDATE_START_PODCAST = "INVALIDATE_START_PODCAST";

export const UPDATE_PODCAST_SESSION_REQUEST = "UPDATE_PODCAST_SESSION_REQUEST";
export const UPDATING_PODCAST_SESSION_SUCCEEDED = "UPDATING_PODCAST_SESSION_SUCCEEDED";
export const UPDATING_PODCAST_SESSION_FAILED = "UPDATING_PODCAST_SESSION_FAILED";

export const FETCH_TRANSCRIPTS_FOR_LEARNING_PODCAST_REQUEST = "FETCH_TRANSCRIPTS_FOR_LEARNING_PODCAST_REQUEST";
export const FETCHING_TRANSCRIPTS_FOR_LEARNING_PODCAST_SUCCEEDED = "FETCHING_TRANSCRIPTS_FOR_LEARNING_PODCAST_SUCCEEDED";
export const FETCHING_TRANSCRIPTS_FOR_LEARNING_PODCAST_FAILED = "FETCHING_TRANSCRIPTS_FOR_LEARNING_PODCAST_FAILED";

export const FETCH_PUBLIC_PODCAST_REQUEST = "FETCH_PUBLIC_PODCAST_REQUEST";
export const FETCHING_PUBLIC_PODCAST_SUCCEEDED = "FETCHING_PUBLIC_PODCAST_SUCCEEDED";
export const FETCHING_PUBLIC_PODCAST_FAILED = "FETCHING_PUBLIC_PODCAST_FAILED";

export const ENROLL_PODCAST_REQUEST = "ENROLL_PODCAST_REQUEST";
export const ENROLLING_PODCAST_SUCCEEDED = "ENROLLING_PODCAST_SUCCEEDED";
export const ENROLLING_PODCAST_FAILED = "ENROLLING_PODCAST_FAILED";

//Scenarios
export const FETCH_PUBLIC_SIMULATION_REQUEST = "FETCH_PUBLIC_SIMULATION_REQUEST";
export const FETCHING_PUBLIC_SIMULATION_SUCCEEDED = "FETCHING_PUBLIC_SIMULATION_SUCCEEDED";
export const FETCHING_PUBLIC_SIMULATION_FAILED = "FETCHING_PUBLIC_SIMULATION_FAILED";

export const FETCH_SCENARIOS = "FETCH_SCENARIOS";
export const FETCHING_SCENARIOS_SUCCEEDED = "FETCHING_SCENARIOS_SUCCEEDED";
export const FETCHING_SCENARIOS_FAILED = "FETCHING_SCENARIOS_FAILED";
export const INVALIDATE_SCENARIOS = "INVALIDATE_SCENARIOS";

export const FETCH_SCENARIO = "FETCH_SCENARIO";
export const FETCHING_SCENARIO_SUCCEEDED = "FETCHING_SCENARIO_SUCCEEDED";
export const FETCHING_SCENARIO_FAILED = "FETCHING_SCENARIO_FAILED";
export const INVALIDATE_SCENARIO = "INVALIDATE_SCENARIO";

export const UPDATE_SCENARIO = "UPDATE_SCENARIO";
export const UPDATING_SCENARIO_SUCCEEDED = "UPDATING_SCENARIO_SUCCEEDED";
export const UPDATING_SCENARIO_FAILED = "UPDATING_SCENARIO_FAILED";
export const INVALIDATE_SCENARIO_UDPATE = "INVALIDATE_SCENARIO_UDPATE";

//Simulations
export const CREATE_PROTO_SIMULATION = "CREATE_PROTO_SIMULATION";
export const CREATING_PROTO_SIMULATION_SUCCEEDED = "CREATING_PROTO_SIMULATION_SUCCEEDED";
export const CREATING_PROTO_SIMULATION_FAILED = "CREATING_PROTO_SIMULATION_FAILED";
export const INVALIDATE_SIMULATION_CREATION = "INVALIDATE_SIMULATION_CREATION";

export const STOP_SIMULATION = "STOP_SIMULATION";

export const ENROLL_SIMULATION_REQUEST = "ENROLL_SIMULATION_REQUEST";
export const ENROLLING_SIMULATION_SUCCEEDED = "ENROLLING_SIMULATION_SUCCEEDED";
export const ENROLLING_SIMULATION_FAILED = "ENROLLING_SIMULATION_FAILED";

//Studio
export const FETCH_DRAFT_COURSES_FOR_STUDIO_REQUEST = "FETCH_DRAFT_COURSES_FOR_STUDIO_REQUEST";
export const FETCHING_DRAFT_COURSES_FOR_STUDIO_SUCCEEDED = "FETCHING_DRAFT_COURSES_FOR_STUDIO_SUCCEEDED";
export const FETCHING_DRAFT_COURSES_FOR_STUDIO_FAILED = "FETCHING_DRAFT_COURSES_FOR_STUDIO_FAILED";

export const FETCH_PUBLISHED_COURSES_FOR_STUDIO_REQUEST = "FETCH_PUBLISHED_COURSES_FOR_STUDIO_REQUEST";
export const FETCHING_PUBLISHED_COURSES_FOR_STUDIO_SUCCEEDED = "FETCHING_PUBLISHED_COURSES_FOR_STUDIO_SUCCEEDED";
export const FETCHING_PUBLISHED_COURSES_FOR_STUDIO_FAILED = "FETCHING_PUBLISHED_COURSES_FOR_STUDIO_FAILED";

// PODCAST
export const CREATE_PODCAST_REQUEST = "CREATE_PODCAST_REQUEST";
export const CREATING_PODCAST_SUCCEEDED = "CREATING_PODCAST_SUCCEEDED";
export const CREATING_PODCAST_FAILED = "CREATING_PODCAST_FAILED";

export const FETCH_DRAFT_PODCAST_REQUEST = "FETCH_DRAFT_PODCAST_REQUEST";
export const FETCHING_DRAFT_PODCAST_SUCCEEDED = "FETCHING_DRAFT_PODCAST_SUCCEEDED";
export const FETCHING_DRAFT_PODCAST_FAILED = "FETCHING_DRAFT_PODCAST_FAILED";
export const INVALIDATE_DRAFT_PODCAST = "INVALIDATE_DRAFT_PODCAST";

export const EDIT_PODCAST_REQUEST = "EDIT_PODCAST_REQUEST";
export const UPDATE_PODCAST_PROPERTY_REQUEST = "UPDATE_PODCAST_PROPERTY_REQUEST";
export const VALIDATE_PODCAST_REQUEST = "VALIDATE_PODCAST_REQUEST";
export const UPDATE_VALIDATION_ERRORS_FOR_PODCAST = "UPDATE_VALIDATION_ERRORS_FOR_PODCAST";

export const UPDATE_PODCAST_REQUEST = "UPDATE_PODCAST_REQUEST";
export const UPDATING_PODCAST_SUCCEEDED = "UPDATING_PODCAST_SUCCEEDED";
export const UPDATING_PODCAST_FAILED = "UPDATING_PODCAST_FAILED";
export const INVALIDATE_PODCAST_CREATION_STATE = " INVALIDATE_PODCAST_CREATION_STATE";
export const INVALIDATE_PODCAST_UPDATE_STATE = "INVALIDATE_PODCAST_UPDATE_STATE";

export const PUBLISH_PODCAST_REQUEST = "PUBLISH_PODCAST_REQUEST";
export const PUBLISHING_PODCAST_SUCCEEDED = "PUBLISHING_PODCAST_SUCCEEDED";
export const PUBLISHING_PODCAST_FAILED = "PUBLISHING_PODCAST_FAILED";
export const INVALIDATE_PUBLISH_PODCAST = "INVALIDATE_PUBLISH_PODCAST";

export const DELETE_PODCAST_REQUEST = "DELETE_PODCAST_REQUEST";
export const DELETING_PODCAST_SUCCEEDED = "DELETING_PODCAST_SUCCEEDED";
export const DELETING_PODCAST_FAILED = "DELETING_PODCAST_FAILED";
export const INVALIDATE_PODCAST_DELETION_STATE = "INVALIDATE_PODCAST_DELETION_STATE";

export const DISCARD_PODCAST_DRAFT_REQUEST = "DISCARD_PODCAST_DRAFT_REQUEST";
export const DISCARDING_PODCAST_DRAFT_SUCCEEDED = "DISCARDING_PODCAST_DRAFT_SUCCEEDED";
export const DISCARDING_PODCAST_DRAFT_FAILED = "DISCARDING_PODCAST_DRAFT_FAILED";

export const INITIATE_PODCAST_EDITOR_REQUEST = "INITIATE_PODCAST_EDITOR_REQUEST";
export const INVALIDATE_PODCAST_EDITOR_REQUEST = "INVALIDATE_PODCAST_EDITOR_REQUEST";

export const CREATING_PODCAST_EDITOR_CHAT_REQUEST = "CREATING_PODCAST_EDITOR_CHAT_REQUEST";
export const CREATING_PODCAST_EDITOR_CHAT_SUCCEEDED = "CREATING_PODCAST_EDITOR_CHAT_SUCCEEDED";
export const CREATING_PODCAST_EDITOR_CHAT_FAILED = "CREATING_PODCAST_EDITOR_CHAT_FAILED";

export const FETCH_PODCAST_TRANSCRIPTION_REQUEST = "FETCH_PODCAST_TRANSCRIPTION_REQUEST";
export const FETCHING_PODCAST_TTRANSCRIPTION_SUCCEEDED = "FETCHING_PODCAST_TRANSCRIPTION_SUCCEEDED";
export const FETCHING_PODCAST_TRANSCRIPTION_FAILED = "FETCHING_PODCAST_TRANSCRIPTION_FAILED";

export const FETCH_PODCAST_TRANSCRIPTION_FOR_EDIT_CHAT_REQUEST = "FETCH_PODCAST_TRANSCRIPTION_FOR_EDIT_CHAT_REQUEST";
export const FETCHING_PODCAST_TRANSCRIPTION_FOR_EDIT_CHAT_SUCCEEDED = "FETCHING_PODCAST_TRANSCRIPTION_FOR_EDIT_CHAT_SUCCEEDED";
export const FETCHING_PODCAST_TRANSCRIPTION_FOR_EDIT_CHAT_FAILED = "FETCHING_PODCAST_TRANSCRIPTION_FOR_EDIT_CHAT_FAILED";

export const GENERATE_TRANSCRIPT_FOR_PODCAST_REQUEST = "GENERATE_TRANSCRIPT_FOR_PODCAST_REQUEST";
export const GENERATING_TRANSCRIPT_FOR_PODCAST_SUCCEEDED = "GENERATING_TRANSCRIPT_FOR_PODCAST_SUCCEEDED";
export const GENERATING_TRANSCRIPT_FOR_PODCAST_FAILED = "GENERATING_TRANSCRIPT_FOR_PODCAST_FAILED";
export const INVALIDATE_TRANSCRIPT_FOR_PODCAST_STATE = "INVALIDATE_TRANSCRIPT_FOR_PODCAST_STATE";

export const GENERATE_AUDIO_FOR_PODCAST_REQUEST = "GENERATE_AUDIO_FOR_PODCAST_REQUEST";
export const GENERATING_AUDIO_FOR_PODCAST_SUCCEEDED = "GENERATING_AUDIO_FOR_PODCAST_SUCCEEDED";
export const GENERATING_AUDIO_FOR_PODCAST_FAILED = "GENERATING_AUDIO_FOR_PODCAST_FAILED";
export const INVALIDATE_AUDIO_FOR_PODCAST_STATE = "INVALIDATE_AUDIO_FOR_PODCAST_STATE";

export const QUICK_GENERATE_PODCAST_REQUEST = "QUICK_GENERATE_PODCAST_REQUEST";
export const QUICK_GENERATING_PODCAST_SUCCEEDED = "QUICK_GENERATING_PODCAST_SUCCEEDED";
export const QUICK_GENERATING_PODCAST_FAILED = "QUICK_GENERATING_PODCAST_FAILED";
export const INVALIDATE_QUICK_GENERATING_PODCAST_STATE = "INVALIDATE_QUICK_GENERATING_PODCAST_STATE";

export const SYNC_PODCAST_PROCESSING_STATE_REQUEST = "SYNC_PODCAST_PROCESSING_STATE_REQUEST";
export const SYNCING_PODCAST_PROCESSING_STATE_SUCCEEDED = "SYNCING_PODCAST_PROCESSING_STATE_SUCCEEDED";
export const SYNCING_PODCAST_PROCESSING_STATE_FAILED = "SYNCING_PODCAST_PROCESSING_STATE_FAILED";

export const WS_PODCAST_TOPICS_GENERATION_COMPLETED = "WS_PODCAST_TOPICS_GENERATION_COMPLETED";
export const WS_PODCAST_TRANSCRIPT_GENERATION_COMPLETED = "WS_PODCAST_TRANSCRIPT_GENERATION_COMPLETED";
export const WS_PODCAST_AUDIO_GENERATION_COMPLETED = "WS_PODCAST_AUDIO_GENERATION_COMPLETED";
export const WS_PODCAST_EDIT_TRANSCRIPT_COMPLETED = "WS_PODCAST_EDIT_TRANSCRIPT_COMPLETED";

export const FETCH_PODCAST_VOICE_PRESETS_REQUEST = "FETCH_PODCAST_VOICE_PRESETS_REQUEST";
export const FETCHING_PODCAST_VOICE_PRESETS_SUCCEEDED = "FETCHING_PODCAST_VOICE_PRESETS_SUCCEEDED";
export const FETCHING_PODCAST_VOICE_PRESETS_FAILED = "FETCHING_PODCAST_VOICE_PRESETS_FAILED";

/**
 * ----------------------------------------------
 * End of Simulation
 */

//linked in 
export const AUTHENTICATING_LINKEDIN_ACCOUNT = "AUTHENTICATING_LINKEDIN_ACCOUNT";
export const AUTHENTICATING_LINKEDIN_ACCOUNT_SUCCEEDED = "AUTHENTICATING_LINKEDIN_ACCOUNT_SUCCEEDED";
export const AUTHENTICATING_LINKEDIN_ACCOUNT_FAILED = "AUTHENTICATING_LINKEDIN_ACCOUNT_FAILED";

export const DEACTIVATE_LINKEDIN_ACCOUNT = "DEACTIVATE_LINKEDIN_ACCOUNT";
export const DEACTIVATING_LINKEDIN_ACCOUNT_SUCCEEDED = "DEACTIVATING_LINKEDIN_ACCOUNT_SUCCEEDED";
export const DEACTIVATING_LINKEDIN_ACCOUNT_FAILED = "DEACTIVATING_LINKEDIN_ACCOUNT_FAILED";

export const FETCH_LINKEDIN_INTEGRATION = "FETCH_LINKEDIN_INTEGRATION";
export const FETCHING_LINKEDIN_INTEGRATION_SUCCEEDED = "FETCHING_LINKEDIN_INTEGRATION_SUCCEEDED";
export const FETCHING_LINKEDIN_INTEGRATION_FAILED = "FETCHING_LINKEDIN_INTEGRATION_FAILED";

export const FETCH_SHARE_TEMPLATE = "FETCH_SHARE_TEMPLATE";
export const FETCHING_SHARE_TEMPLATE_SUCCEEDED = "FETCHING_SHARE_TEMPLATE_SUCCEEDED";
export const FETCHING_SHARE_TEMPLATE_FAILED = "FETCHING_SHARE_TEMPLATE_FAILED";
 
export const UPDATE_SHARE_TEMPLATE = "UPDATE_SHARE_TEMPLATE";
export const UPDATING_SHARE_TEMPLATE_SUCCEEDED = "UPDATING_SHARE_TEMPLATE_SUCCEEDED";
export const UPDATING_SHARE_TEMPLATE_FAILED = "UPDATING_SHARE_TEMPLATE_FAILED";

export const INVALIDATE_LINKEDIN_INTEGRATION = "INVALIDATE_LINKEDIN_INTEGRATION";

export const INVALIDATE_SHARE_SETTINGS_UPDATE = "INVALIDATE_SHARE_SETTINGS_UPDATE";

export const SHARE_LINKEDIN_POST_REQUEST = "SHARE_LINKEDIN_POST_REQUEST";
export const SHARING_LINKEDIN_POST_SUCCEEDED = "SHARING_LINKEDIN_POST_SUCCEEDED";
export const SHARING_LINKEDIN_POST_FAILED = "SHARING_LINKEDIN_POST_FAILED";

export const FETCH_LINKEDIN_POST = "FETCH_LINKEDIN_POST";
export const FETCHING_LINKEDIN_POST_SUCCEEDED = "FETCHING_LINKEDIN_POST_SUCCEEDED";
export const FETCHING_LINKEDIN_POST_FAILED = "FETCHING_LINKEDIN_POST_FAILED";

export const INVALIDATE_LINKEDIN_POSTS = "INVALIDATE_LINKEDIN_POSTS";

export const DELETE_LINKEDIN_SCHEDULED_POST = "DELETE_LINKEDIN_SCHEDULED_POST";
export const DELETING_LINKEDIN_SCHEDULED_POST_SUCCEEDED = "DELETING_LINKEDIN_SCHEDULED_POST_SUCCEEDED";
export const DELETING_LINKEDIN_SCHEDULED_POST_FAILED = "DELETING_LINKEDIN_SCHEDULED_POST_FAILED";

export const INVALIDATE_LINKEDIN_POST = "INVALIDATE_LINKEDIN_POST";

export const REPHARSE_LINKEDIN_POST = "REPHARSE_LINKEDIN_POST";
export const REPHARSING_LINKEDIN_POST_SUCCEEDED = "REPHARSING_LINKEDIN_POST_SUCCEEDED";
export const REPHARSING_LINKEDIN_POST_FAILED = "REPHARSING_LINKEDIN_POST_FAILED";

export const INVALIDATE_LINKEDIN_POST_TONES = "INVALIDATE_LINKEDIN_POST_TONES";
export const FETCH_LINKEDIN_ORGANIZATION = "FETCH_LINKEDIN_ORGANIZATION";
export const FETCHING_LINKEDIN_ORGANIZATION_SUCCEEDED = "FETCHING_LINKEDIN_ORGANIZATION_SUCCEEDED";
export const FETCHING_LINKEDIN_ORGANIZATION_FAILED = "FETCHING_LINKEDIN_ORGANIZATION_FAILED";

//contacts
export const FETCHING_INTEGRATION_CONTACTS = "FETCHING_INTEGRATION_CONTACTS";
export const FETCHING_INTEGRATION_CONTACTS_SUCCEEDED = "FETCHING_INTEGRATION_CONTACTS_SUCCEEDED";
export const FETCHING_INTEGRATION_CONTACTS_FAILED = "FETCHING_INTEGRATION_CONTACTS_FAILED";

export const INVALIDATE_INTEGRATION_CONTACTS = "INVALIDATE_INTEGRATION_CONTACTS";


//Email Templates
export const FETCH_EMAIL_TEMPLATES_REQUEST = "FETCH_EMAIL_TEMPLATES_REQUEST";
export const FETCHING_EMAIL_TEMPLATES_SUCCEDDED = "FETCHING_EMAIL_TEMPLATES_SUCCEDDED";
export const FETCHING_EMAIL_TEMPLATES_FAILED = "FETCHING_EMAIL_TEMPLATES_FAILED";
export const INVALIDATE_EMAIL_TEMPLATES = "INVALIDATE_EMAIL_TEMPLATES";

export const SELECTION_EMAIL_TEMPLATE = "SELECTION_EMAIL_TEMPLATE";
export const INVALIDATE_SELECTION_EMAIL_TEMPLATE = "INVALIDATE_SELECTION_EMAIL_TEMPLATE";

export const FETCH_EMAIL_TEMPLATE_REQUEST = "FETCH_EMAIL_TEMPLATE_REQUEST";
export const FETCHING_EMAIL_TEMPLATE_SUCCEDDED = "FETCHING_EMAIL_TEMPLATE_SUCCEDDED";
export const FETCHING_EMAIL_TEMPLATE_FAILED = "FETCHING_EMAIL_TEMPLATE_FAILED";

export const FETCH_DEFAULT_EMAIL_TEMPLATE_REQUEST = "FETCH_DEFAULT_EMAIL_TEMPLATE_REQUEST";
export const FETCHING_DEFAULT_EMAIL_TEMPLATE_SUCCEDDED = "FETCHING_DEFAULT_EMAIL_TEMPLATE_SUCCEDDED";
export const FETCHING_DEFAULT_EMAIL_TEMPLATE_FAILED = "FETCHING_DEFAULT_EMAIL_TEMPLATE_FAILED";

//Content Recommendations
export const FETCHING_CONTENT_RECOMMENDATIONS_REQUEST = 'FETCHING_CONTENT_RECOMMENDATIONS_REQUEST';
export const FETCHING_CONTENT_RECOMMENDATIONS_SUCCEDDED = 'FETCHING_CONTENT_RECOMMENDATIONS_SUCCEDDED';
export const FETCHING_CONTENT_RECOMMENDATIONS_FAILED = 'FETCHING_CONTENT_RECOMMENDATIONS_FAILED';

//contacts
export const FETCH_CONTACT_REQUEST = "FETCH_CONTACT_REQUEST";
export const FETCHING_CONTACT_SUCCEEDED = "FETCHING_CONTACT_SUCCEEDED";
export const FETCHING_CONTACT_FAILED = "FETCHING_CONTACT_FAILED";

export const FETCH_SHARES_FOR_CONTACT_REQUEST = "FETCH_SHARES_FOR_CONTACT_REQUEST"
export const FETCHING_SHARES_FOR_CONTACT_REQUEST_SUCCEEDED = "FETCHING_SHARES_FOR_CONTACT_REQUEST_SUCCEEDED"
export const FETCHING_SHARES_FOR_CONTACT_REQUEST_FAILED = "FETCHING_SHARES_FOR_CONTACT_REQUEST_FAILED"

export const FETCH_CONTENTS_FOR_SHARE = "FETCH_CONTENTS_FOR_SHARE"
export const FETCHING_CONTENTS_FOR_SHARE_SUCCEEDED = "FETCHING_CONTENTS_FOR_SHARE_SUCCEEDED"
export const FETCHING_CONTENTS_FOR_SHARE_FAILED = "FETCHING_CONTENTS_FOR_SHARE_FAILED"

export const FETCH_CONTACT_ASSET_ANALYTICS_REQUEST = "FETCH_CONTACT_ASSET_ANALYTICS_REQUEST";
export const FETCHING_CONTACT_ASSET_ANALYTICS_SUCCEEDED = "FETCHING_CONTACT_ASSET_ANALYTICS_SUCCEEDED";
export const FETCHING_CONTACT_ASSET_ANALYTICS_FAILED = "FETCHING_CONTACT_ASSET_ANALYTICS_FAILED";

export const FETCH_CONTACT_SHARE_SECTION_REQUEST = "FETCH_CONTACT_SHARE_SECTION_REQUEST"
export const FETCHING_CONTACT_SHARE_SECTION_SUCCEEDED = "FETCHING_CONTACT_SHARE_SECTION_SUCCEEDED"
export const FETCHING_CONTACT_SHARE_SECTION_FAILED = "FETCHING_CONTACT_SHARE_SECTION_FAILED"

export const UPDATE_CONTACT_REQUEST = "UPDATE_CONTACT_REQUEST";
export const UPDATING_CONTACT_SUCCEEDED = "UPDATING_CONTACT_SUCCEEDED";
export const UPDATING_CONTACT_FAILED = "UPDATING_CONTACT_FAILED";
export const INVALIDATE_CONTACT_UPDATIONS = "INVALIDATE_CONTACT_UPDATIONS"

// Invalidate conversation
export const INVALIDATE_CONVERSATION_CONTACT = "INVALIDATE_CONVERSATION_CONTACT";

export const FETCH_ORGANIZATION_REQUEST = "FETCH_ORGANIZATION_REQUEST";
export const FETCHING_ORGANIZATION_SUCCEEDED = "FETCHING_ORGANIZATION_SUCCEEDED";
export const FETCHING_ORGANIZATION_FAILED = "FETCHING_ORGANIZATION_FAILED";
export const INVALIDATE_ORGANIZATIONS = "INVALIDATE_ORGANIZATIONS";

//opportunities
export const FETCH_INTEGRATION_OPPORTUNITIES_REQUEST = "FETCH_INTEGRATION_OPPORTUNITIES"
export const FETCHING_INTEGRATION_OPPORTUNITIES_SUCCEEDED = "FETCHING_INTEGRATION_OPPORTUNITIES_SUCCEEDED"
export const FETCHING_INTEGRATION_OPPORTUNITIES_FAILED = "FETCHING_INTEGRATION_OPPORTUNITIES_FAILED"
export const INVALIDATE_INTEGRATION_OPPORTUNITIES = "INVALIDATE_INTEGRATION_OPPORTUNITIES";

// deal room
export const FETCHING_STAKEHOLDERS = "FETCHING_STAKEHOLDERS";
export const FETCHING_STAKEHOLDERS_SUCCEEDED = "FETCHING_STAKEHOLDERS_SUCCEEDED";
export const FETCHING_STAKEHOLDERS_FAILED = "FETCHING_STAKEHOLDERS_FAILED";

export const DELETING_STAKEHOLDER = "DELETING_STAKEHOLDER";
export const DELETING_STAKEHOLDER_SUCCEEDED = "DELETING_STAKEHOLDER_SUCCEEDED";
export const DELETING_STAKEHOLDER_FAILED = "DELETING_STAKEHOLDER_FAILED";

export const INVALIDATE_DEAL_ROOM_CREATION_STATE = "INVALIDATE_DEAL_ROOM_CREATION_STATE";
export const EDIT_DEAL_ROOM_REQUEST = "EDIT_DEAL_ROOM_REQUEST";
export const DEAL_ROOM_UPDATE_PROPERTY = "DEAL_ROOM_UPDATE_PROPERTY";
export const INVALIDATE_DEAL_ROOM_EDIT_STATE = "INVALIDATE_DEAL_ROOM_EDIT_STATE";
export const INVALIDATE_DEAL_ROOM_UPDATE_STATE = "INVALIDATE_DEAL_ROOM_UPDATE_STATE";
export const REARRANGE_DEAL_ROOM_ASSETS = "REARRANGE_DEAL_ROOM_ASSETS"

export const DEAL_ROOM_ADD_ASSETS = "DEAL_ROOM_ADD_ASSETS";
export const DEAL_ROOM_REMOVE_ASSETS = "DEAL_ROOM_REMOVE_ASSETS";
export const DEAL_ROOM_REARRANGE_ASSETS = "DEAL_ROOM_REARRANGE_ASSETS";
export const DEAL_ROOM_UPDATE_ASSET_METADATA = "DEAL_ROOM_UPDATE_ASSET_METADATA";
export const DEAL_ROOM_MOVE_SECTIONS = "DEAL_ROOM_MOVE_SECTIONS";

export const DEAL_ROOM_MOVE_ASSET_TO_SECTION = "DEAL_ROOM_MOVE_ASSET_TO_SECTION";

export const FETCH_DEAL_ROOM_ASSETS = "FETCH_DEAL_ROOM_ASSETS";
export const FETCHING_DEAL_ROOM_ASSETS_SUCCEEDED = "FETCHING_DEAL_ROOM_ASSETS_SUCCEEDED";
export const FETCHING_DEAL_ROOM_ASSETS_FAILED = "FETCHING_DEAL_ROOM_ASSETS_FAILED";

export const FETCH_DEAL_ROOM_ASSETS_FOR_SECTION = "FETCH_DEAL_ROOM_ASSETS_FOR_SECTION";
export const FETCHING_DEAL_ROOM_ASSETS_FOR_SECTION_SUCCEEDED = "FETCHING_DEAL_ROOM_ASSETS_FOR_SECTION_SUCCEEDED";
export const FETCHING_DEAL_ROOM_ASSETS_FOR_SECTION_FAILED = "FETCHING_DEAL_ROOM_ASSETS_FOR_SECTION_FAILED"; 

export const FETCH_DEAL_ROOM_COLLABORATORS_REQUEST = "FETCH_DEAL_ROOM_COLLABORATORS_REQUEST";
export const FETCHING_DEAL_ROOM_COLLABORATORS_SUCCEDDED = "FETCHING_DEAL_ROOM_COLLABORATORS_SUCCEDDED";
export const FETCHING_DEAL_ROOM_COLLABORATORS_FAILED = "FETCHING_DEAL_ROOM_COLLABORATORS_FAILED";

export const CREATE_DEAL_ROOM_SECTION_REQUEST = "CREATE_DEAL_ROOM_SECTION_REQUEST";
export const UPDATE_DEAL_ROOM_SECTION_REQUEST = "UPDATE_DEAL_ROOM_SECTION_REQUEST";
export const REMOVE_DEAL_ROOM_SECTION_REQUEST = "REMOVE_DEAL_ROOM_SECTION_REQUEST";
export const MOVE_DEAL_ROOM_SECTION_REQUEST = "MOVE_DEAL_ROOM_SECTION_REQUEST";

export const UPDATE_DEAL_ROOM_COLLABORATORS_REQUEST = "UPDATE_DEAL_ROOM_COLLABORATORS_REQUEST";
export const UPDATING_DEAL_ROOM_COLLABORATORS_SUCCEDDED = "UPDATING_DEAL_ROOM_COLLABORATORS_SUCCEDDED";
export const UPDATING_DEAL_ROOM_COLLABORATORS_FAILED = "UPDATING_DEAL_ROOM_COLLABORATORS_FAILED";

export const FETCH_DEAL_ROOM_SHARED_ASSETS = "FETCH_DEAL_ROOM_SHARED_ASSETS";
export const FETCHING_DEAL_ROOM_SHARED_ASSETS_SUCCEEDED = "FETCHING_DEAL_ROOM_SHARED_ASSETS_SUCCEEDED";
export const FETCHING_DEAL_ROOM_SHARED_ASSETS_FAILED = "FETCHING_DEAL_ROOM_SHARED_ASSETS_FAILED";

export const FETCH_DEAL_ROOM_SHARED_COLLECTIONS = "FETCH_DEAL_ROOM_SHARED_COLLECTIONS";
export const FETCHING_DEAL_ROOM_SHARED_COLLECTIONS_SUCCEEDED = "FETCHING_DEAL_ROOM_SHARED_COLLECTIONS_SUCCEEDED";
export const FETCHING_DEAL_ROOM_SHARED_COLLECTIONS_FAILED = "FETCHING_DEAL_ROOM_SHARED_COLLECTIONS_FAILED";

export const FETCH_DEAL_ROOM_DETAILS = "FETCH_DEAL_ROOM_DETAILS";
export const FETCHING_DEAL_ROOM_DETAILS_SUCCEEDED = "FETCHING_DEAL_ROOM_DETAILS_SUCCEEDED";
export const FETCHING_DEAL_ROOM_DETAILS_FAILED = "FETCHING_DEAL_ROOM_DETAILS_FAILED";

export const FETCH_DEAL_ROOM_SIGNALS = "FETCH_DEAL_ROOM_SIGNALS";
export const FETCHING_DEAL_ROOM_SIGNALS_SUCCEEDED = "FETCHING_DEAL_ROOM_SIGNALS_SUCCEEDED";
export const FETCHING_DEAL_ROOM_SIGNALS_FAILED = "FETCHING_DEAL_ROOM_SIGNALS_FAILED";

export const FETCH_DEAL_ROOM_HISTORY = "FETCH_DEAL_ROOM_HISTORY";
export const FETCHING_DEAL_ROOM_HISTORY_SUCCEEDED = "FETCHING_DEAL_ROOM_HISTORY_SUCCEEDED";
export const FETCHING_DEAL_ROOM_HISTORY_FAILED = "FETCHING_DEAL_ROOM_HISTORY_FAILED";
export const INVALIDATE_DEAL_ROOM_COLLABORATORS = "INVALIDATE_DEAL_ROOM_COLLABORATORS";

export const FETCH_CHAT_USERS_FOR_DEAL_ROOM = "FETCH_CHAT_USERS_FOR_DEAL_ROOM";
export const FETCHING_CHAT_USERS_FOR_DEAL_ROOM_SUCCEEDED = "FETCHING_CHAT_USERS_FOR_DEAL_ROOM_SUCCEEDED";
export const FETCHING_CHAT_USERS_FOR_DEAL_ROOM_FAILED = "FETCHING_CHAT_USERS_FOR_DEAL_ROOM_FAILED";
// default hub layout creation
export const CREATE_HUB_LAYOUT = "CREATE_HUB_LAYOUT"
export const CREATING_HUB_LAYOUT_SUCCEEDED = "CREATING_HUB_LAYOUT_SUCCEEDED"
export const CREATING_HUB_LAYOUT_FAILED = "CREATING_HUB_LAYOUT_FAILED"

export const INVALIDATE_HUB_LAYOUT_CREATION = "INVALIDATE_HUB_LAYOUT_CREATION"

export const FETCH_DEAL_ROOM_CHAT_USERS_REQUEST = "FETCH_DEAL_ROOM_CHAT_USERS_REQUEST";
export const FETCHING_DEAL_ROOM_CHAT_USERS_SUCCEEDED = "FETCHING_DEAL_ROOM_CHAT_USERS_SUCCEEDED";
export const FETCHING_DEAL_ROOM_CHAT_USERS_FAILED = "FETCHING_DEAL_ROOM_CHAT_USERS_FAILED";

export const FETCH_DEAL_ROOM_ACTIVE_CHAT_USER_REQUEST = "FETCH_DEAL_ROOM_ACTIVE_CHAT_USER_REQUEST";
export const FETCHING_DEAL_ROOM_ACTIVE_CHAT_USER_SUCCEEDED = "FETCHING_DEAL_ROOM_ACTIVE_CHAT_USER_SUCCEEDED";
export const FETCHING_DEAL_ROOM_ACTIVE_CHAT_USER_FAILED = "FETCHING_DEAL_ROOM_ACTIVE_CHAT_USER_FAILED";

export const FETCH_DEAL_ROOM_SMARTCARDS = "FETCH_DEAL_ROOM_SMARTCARDS";
export const FETCHING_DEAL_ROOM_SMARTCARDS_SUCCEEDED = "FETCHING_DEAL_ROOM_SMARTCARDS_SUCCEEDED";
export const FETCHING_DEAL_ROOM_SMARTCARDS_FAILED = "FETCHING_DEAL_ROOM_SMARTCARDS_FAILED";

export const FETCH_DEAL_ROOM_ASSET_ANALYTICS_REQUEST = "FETCH_DEAL_ROOM_ASSET_ANALYTICS_REQUEST";
export const FETCHING_DEAL_ROOM_ASSET_ANALYTICS_SUCCEEDED = "FETCHING_DEAL_ROOM_ASSET_ANALYTICS_SUCCEEDED";
export const FETCHING_DEAL_ROOM_ASSET_ANALYTICS_FAILED = "FETCHING_DEAL_ROOM_ASSET_ANALYTICS_FAILED";

export const FETCH_DEAL_ROOM_EVENTS = "FETCH_DEAL_ROOM_EVENTS";
export const FETCHING_DEAL_ROOM_EVENTS_SUCCEEDED = "FETCHING_DEAL_ROOM_EVENTS_SUCCEEDED";
export const FETCHING_DEAL_ROOM_EVENTS_FAILED = "FETCHING_DEAL_ROOM_EVENTS_FAILED";


//Recording Referral Info
export const RECORDING_REFERRAL_INFO = "RECORDING_REFERRAL_INFO";
export const RECORDING_REFERRAL_INFO_SUCCEEDED = "RECORDING_REFERRAL_INFO_SUCCEEDED";
export const RECORDING_REFERRAL_INFO_FAILED = "RECORDING_REFERRAL_INFO_FAILED";


// content similarity
export const ADD_ASSET_TO_CONTENT_SIMILARITY_QUEUE = "ADD_ASSET_TO_CONTENT_SIMILARITY_QUEUE";
export const TOGGLE_ASSET_STATUS_IN_CONTENT_SIMILARITY_QUEUE = "TOGGLE_ASSET_STATUS_IN_CONTENT_SIMILARITY_QUEUE";

// fetch duplicate assets
export const FETCH_DUPLICATE_ASSET = "FETCH_DUPLICATE_ASSET";
export const FETCHING_DUPLICATE_ASSET_SUCCEDDED = "FETCHING_DUPLICATE_ASSET_SUCCEDDED";
export const FETCHING_DUPLICATE_ASSET_FAILED = "FETCHING_DUPLICATE_ASSET_FAILED";

// replace similar assets
export const REPLACE_SIMILAR_ASSET = "REPLACE_SIMILAR_ASSET";
export const REPLACE_SIMILAR_ASSET_SUCCEEDED = "REPLACE_SIMILAR_ASSET_SUCCEEDED";
export const REPLACE_SIMILAR_ASSET_FAILED = "REPLACE_SIMILAR_ASSET_FAILED";

// invalidate similar assets
export const INVALIDATE_SIMILAR_ASSET = "INVALIDATE_SIMILAR_ASSET";

//invalidate stream children
export const INVALIDATE_STREAM_CHILDREN = "INVALIDATE_STREAM_CHILDREN";

//invalidate group children
export const INVALIDATE_GROUP_CHILDREN = "INVALIDATE_GROUP_CHILDREN";
//table of contents
export const FETCH_TABLE_OF_CONTENTS = "FETCH_TABLE_OF_CONTENTS";
export const FETCHING_TABLE_OF_CONTENTS_SUCCEEDED = "FETCHING_TABLE_OF_CONTENTS_SUCCEEDED";
export const FETCHING_TABLE_OF_CONTENTS_FAILED = "FETCHING_TABLE_OF_CONTENTS_FAILED";

export const UPDATE_TABLE_OF_CONTENTS = "UPDATE_TABLE_OF_CONTENTS";
export const UPDATING_TABLE_OF_CONTENTS_SUCCEEDED = "UPDATING_TABLE_OF_CONTENTS_SUCCEEDED";
export const UPDATING_TABLE_OF_CONTENTS_FAILED = "UPDATING_TABLE_OF_CONTENTS_FAILED";
export const INVALIDATE_UPDATE_TABLE_OF_CONTENTS = "INVALIDATE_UPDATE_TABLE_OF_CONTENTS";
export const INVALIDATE_TABLE_OF_CONTENTS = "INVALIDATE_TABLE_OF_CONTENTS";

export const DELETE_TABLE_OF_CONTENTS = "DELETE_TABLE_OF_CONTENTS";
export const DELETING_TABLE_OF_CONTENTS_SUCCEEDED = "DELETING_TABLE_OF_CONTENTS_SUCCEEDED";
export const DELETING_TABLE_OF_CONTENTS_FAILED = "DELETING_TABLE_OF_CONTENTS_FAILED";

// invalidate asset
export const INVALIDATE_ASSET = "INVALIDATE_ASSET";

//Dashboard Report 
export const FETCHING_DISCOVERY_POPULAR_ASSETS =
  "FETCHING_DISCOVERY_POPULAR_ASSETS";
export const FETCHING_DISCOVERY_POPULAR_ASSETS_SUCCEDDED =
  "FETCHING_DISCOVERY_POPULAR_ASSETS_SUCCEDDED";
export const FETCHING_DISCOVERY_POPULAR_ASSETS_FAILED =
  "FETCHING_DISCOVERY_POPULAR_ASSETS_FAILED";

export const FETCHING_ACCOUNT_SUMMARY_NUDGES_REQUEST =
  "FETCHING_ACCOUNT_SUMMARY_NUDGES_REQUEST";
export const FETCHING_ACCOUNT_SUMMARY_NUDGES_SUCCEDDED =
  "FETCHING_ACCOUNT_SUMMARY_NUDGES_SUCCEDDED";
export const FETCHING_ACCOUNT_SUMMARY_NUDGES_FAILED =
  "FETCHING_ACCOUNT_SUMMARY_NUDGES_FAILED";

export const FETCHING_DISCOVERY_ASSETS_SHARED_REPORT =
  "FETCHING_DISCOVERY_ASSETS_SHARED_REPORT";
export const FETCHING_DISCOVERY_ASSETS_SHARED_REPORT_SUCCEDDED =
  "FETCHING_DISCOVERY_ASSETS_SHARED_REPORT_SUCCEDDED";
export const FETCHING_DISCOVERY_ASSETS_SHARED_REPORT_FAILED =
  "FETCHING_DISCOVERY_ASSETS_SHARED_REPORT_FAILED";

export const FETCHING_DISCOVERY_TOP_USERS = 
  "FETCHING_DISCOVERY_TOP_USERS";
export const FETCHING_DISCOVERY_TOP_USERS_SUCCEDDED =
  "FETCHING_DISCOVERY_TOP_USERS_SUCCEDDED";
export const FETCHING_DISCOVERY_TOP_USERS_FAILED =
  "FETCHING_DISCOVERY_TOP_USERS_FAILED";

export const FETCHING_DISCOVERY_TOP_SHARERS = 
  "FETCHING_DISCOVERY_TOP_SHARERS";
export const FETCHING_DISCOVERY_TOP_SHARERS_SUCCEEDED =
  "FETCHING_DISCOVERY_TOP_SHARERS_SUCCEEDED";
export const FETCHING_DISCOVERY_TOP_SHARERS_FAILED =
  "FETCHING_DISCOVERY_TOP_SHARERS_FAILED";

export const FETCHING_DISCOVERY_TOP_USER_GROUPS =
  "FETCHING_DISCOVERY_TOP_USER_GROUPS";
export const FETCHING_DISCOVERY_TOP_USER_GROUPS_SUCCEDDED =
  "FETCHING_DISCOVERY_TOP_USER_GROUPS_SUCCEDDED";
export const FETCHING_DISCOVERY_TOP_USER_GROUPS_FAILED =
  "FETCHING_DISCOVERY_TOP_USER_GROUPS_FAILED";

export const FETCHING_DISCOVERY_COLLECTIONS_REPORT =
  "FETCHING_DISCOVERY_COLLECTIONS_REPORT";
export const FETCHING_DISCOVERY_COLLECTIONS_REPORT_SUCCEDDED =
  "FETCHING_DISCOVERY_COLLECTIONS_REPORT_SUCCEDDED";
export const FETCHING_DISCOVERY_COLLECTIONS_REPORT_FAILED =
  "FETCHING_DISCOVERY_COLLECTIONS_REPORT_FAILED";

export const FETCHING_DISCOVERY_COLLECTIONS_SHARED_REPORT =
  "FETCHING_DISCOVERY_COLLECTIONS_SHARED_REPORT";
export const FETCHING_DISCOVERY_COLLECTIONS_SHARED_REPORT_SUCCEDDED =
  "FETCHING_DISCOVERY_COLLECTIONS_SHARED_REPORT_SUCCEDDED";
export const FETCHING_DISCOVERY_COLLECTIONS_SHARED_REPORT_FAILED =
  "FETCHING_DISCOVERY_COLLECTIONS_SHARED_REPORT_FAILED";

export const FETCHING_DISCOVERY_SEARCH_QUERIES =
  "FETCHING_DISCOVERY_SEARCH_QUERIES";
export const FETCHING_DISCOVERY_SEARCH_QUERIES_SUCCEDDED =
  "FETCHING_DISCOVERY_SEARCH_QUERIES_SUCCEDDED";
export const FETCHING_DISCOVERY_SEARCH_QUERIES_FAILED =
  "FETCHING_DISCOVERY_SEARCH_QUERIES_FAILED";

export const FETCHING_DISCOVERY_SEARCH_TAGS = "FETCHING_DISCOVERY_SEARCH_TAGS";
export const FETCHING_DISCOVERY_SEARCH_TAGS_SUCCEDDED =
    "FETCHING_DISCOVERY_SEARCH_TAGS_SUCCEDDED";
export const FETCHING_DISCOVERY_SEARCH_TAGS_FAILED =
    "FETCHING_DISCOVERY_SEARCH_TAGS_FAILED";

export const FETCHING_DISCOVERY_ASSET_VIEWS_GRAPH_REPORT =
    "FETCHING_DISCOVERY_ASSET_VIEWS_GRAPH_REPORT";
export const FETCHING_DISCOVERY_ASSET_VIEWS_GRAPH_REPORT_SUCCEDDED =
    "FETCHING_DISCOVERY_ASSET_VIEWS_GRAPH_REPORT_SUCCEDDED";
export const FETCHING_DISCOVERY_ASSET_VIEWS_GRAPH_REPORT_FAILED =
    "FETCHING_DISCOVERY_ASSET_VIEWS_GRAPH_REPORT_FAILED";

export const FETCHING_DISCOVERY_ASSET_GRAPH_REPORT =
    "FETCHING_DISCOVERY_ASSET_GRAPH_REPORT";
export const FETCHING_DISCOVERY_ASSET_GRAPH_REPORT_SUCCEDDED =
    "FETCHING_DISCOVERY_ASSET_GRAPH_REPORT_SUCCEDDED";
export const FETCHING_DISCOVERY_ASSET_GRAPH_REPORT_FAILED =
    "FETCHING_DISCOVERY_ASSET_GRAPH_REPORT_FAILED";
  
export const FETCHING_DISCOVERY_COLLECTION_ACTIVITY_GRAPH_REPORT =
    "FETCHING_DISCOVERY_COLLECTION_ACTIVITY_GRAPH_REPORT";
export const FETCHING_DISCOVERY_COLLECTION_ACTIVITY_GRAPH_REPORT_SUCCEDDED =
    "FETCHING_DISCOVERY_COLLECTION_ACTIVITY_GRAPH_REPORT_SUCCEDDED";
export const FETCHING_DISCOVERY_COLLECTION_ACTIVITY_GRAPH_REPORT_FAILED =
    "FETCHING_DISCOVERY_COLLECTION_ACTIVITY_GRAPH_REPORT_FAILED";

export const FETCHING_DISCOVERY_SHARE_GRAPH_REPORT =
    "FETCHING_DISCOVERY_SHARE_GRAPH_REPORT";
export const FETCHING_DISCOVERY_SHARE_GRAPH_REPORT_SUCCEDDED =
    "FETCHING_DISCOVERY_SHARE_GRAPH_REPORT_SUCCEDDED";
export const FETCHING_DISCOVERY_SHARE_GRAPH_REPORT_FAILED =
    "FETCHING_DISCOVERY_SHARE_GRAPH_REPORT_FAILED";

export const FETCHING_DISCOVERY_CONTENT_MATRIX_ASSETS_REQUEST =
    "FETCHING_DISCOVERY_CONTENT_MATRIX_ASSETS_REQUEST";
export const FETCHING_DISCOVERY_CONTENT_MATRIX_ASSETS_SUCCEDDED =
    "FETCHING_DISCOVERY_CONTENT_MATRIX_ASSETS_SUCCEDDED";
export const FETCHING_DISCOVERY_CONTENT_MATRIX_ASSETS_FAILED =
    "FETCHING_DISCOVERY_CONTENT_MATRIX_ASSETS_FAILED";

export const INVALIDATE_DISCOVERY_CONTENT_MATRIX_ASSETS =
  "INVALIDATE_DISCOVERY_CONTENT_MATRIX_ASSETS";

export const FETCHING_DISCOVERY_CONTENT_MATRIX_REQUEST =
    "FETCHING_DISCOVERY_CONTENT_MATRIX_REQUEST";
export const FETCHING_DISCOVERY_CONTENT_MATRIX_SUCCEDDED =
    "FETCHING_DISCOVERY_CONTENT_MATRIX_SUCCEDDED";
export const FETCHING_DISCOVERY_CONTENT_MATRIX_FAILED =
    "FETCHING_DISCOVERY_CONTENT_MATRIX_FAILED";

export const FETCHING_ENGAGEMENT_ATTENTION_TIME_GRAPH_REPORT =
    "FETCHING_ENGAGEMENT_ATTENTION_TIME_GRAPH_REPORT";
export const FETCHING_ENGAGEMENT_ATTENTION_TIME_GRAPH_REPORT_SUCCEDDED =
    "FETCHING_ENGAGEMENT_ATTENTION_TIME_GRAPH_REPORT_SUCCEDDED";
export const FETCHING_ENGAGEMENT_ATTENTION_TIME_GRAPH_REPORT_FAILED =
    "FETCHING_ENGAGEMENT_ATTENTION_TIME_GRAPH_REPORT_FAILED";

export const FETCHING_ENGAGEMENT_UNIQUE_VIEWERS_GRAPH_REPORT =
    "FETCHING_ENGAGEMENT_UNIQUE_VIEWERS_GRAPH_REPORT";
export const FETCHING_ENGAGEMENT_UNIQUE_VIEWERS_GRAPH_REPORT_SUCCEDDED =
    "FETCHING_ENGAGEMENT_UNIQUE_VIEWERS_GRAPH_REPORT_SUCCEDDED";
export const FETCHING_ENGAGEMENT_UNIQUE_VIEWERS_GRAPH_REPORT_FAILED =
    "FETCHING_ENGAGEMENT_UNIQUE_VIEWERS_GRAPH_REPORT_FAILED";

export const FETCHING_ENGAGEMENT_SHARE_GRAPH_REPORT =
    "FETCHING_ENGAGEMENT_SHARE_GRAPH_REPORT";
export const FETCHING_ENGAGEMENT_SHARE_GRAPH_REPORT_SUCCEDDED =
    "FETCHING_ENGAGEMENT_SHARE_GRAPH_REPORT_SUCCEDDED";
export const FETCHING_ENGAGEMENT_SHARE_GRAPH_REPORT_FAILED =
    "FETCHING_ENGAGEMENT_SHARE_GRAPH_REPORT_FAILED";

export const FETCHING_ENGAGEMENT_ASSET_VIEWS_GRAPH_REPORT =
    "FETCHING_ENGAGEMENT_ASSET_VIEWS_GRAPH_REPORT";
export const FETCHING_ENGAGEMENT_ASSET_VIEWS_GRAPH_REPORT_SUCCEDDED =
    "FETCHING_ENGAGEMENT_ASSET_VIEWS_GRAPH_REPORT_SUCCEDDED";
export const FETCHING_ENGAGEMENT_ASSET_VIEWS_GRAPH_REPORT_FAILED =
    "FETCHING_ENGAGEMENT_ASSET_VIEWS_GRAPH_REPORT_FAILED";

export const FETCHING_ENGAGEMENT_POPULAR_ASSETS =
    "FETCHING_ENGAGEMENT_POPULAR_ASSETS";
export const FETCHING_ENGAGEMENT_POPULAR_ASSETS_SUCCEDDED =
    "FETCHING_ENGAGEMENT_POPULAR_ASSETS_SUCCEDDED";
export const FETCHING_ENGAGEMENT_POPULAR_ASSETS_FAILED =
    "FETCHING_ENGAGEMENT_POPULAR_ASSETS_FAILED";

export const FETCHING_ENGAGEMENT_TOP_USERS = "FETCHING_ENGAGEMENT_TOP_USERS";
export const FETCHING_ENGAGEMENT_TOP_USERS_SUCCEDDED =
      "FETCHING_ENGAGEMENT_TOP_USERS_SUCCEDDED";
export const FETCHING_ENGAGEMENT_TOP_USERS_FAILED =
      "FETCHING_ENGAGEMENT_TOP_USERS_FAILED";

export const FETCHING_ENGAGEMENT_TOP_ACCOUNTS =
      "FETCHING_ENGAGEMENT_TOP_ACCOUNTS";
export const FETCHING_ENGAGEMENT_TOP_ACCOUNTS_SUCCEDDED =
      "FETCHING_ENGAGEMENT_TOP_ACCOUNTS_SUCCEDDED";
export const FETCHING_ENGAGEMENT_TOP_ACCOUNTS_FAILED =
      "FETCHING_ENGAGEMENT_TOP_ACCOUNTS_FAILED";

export const FETCHING_ENGAGEMENT_TOP_CAMPAIGNS =
      "FETCHING_ENGAGEMENT_TOP_CAMPAIGNS";
export const FETCHING_ENGAGEMENT_TOP_CAMPAIGNS_SUCCEDDED =
      "FETCHING_ENGAGEMENT_TOP_CAMPAIGNS_SUCCEDDED";
export const FETCHING_ENGAGEMENT_TOP_CAMPAIGNS_FAILED =
      "FETCHING_ENGAGEMENT_TOP_CAMPAIGNS_FAILED";
    
export const FETCHING_ENGAGEMENT_TOP_CAMPAIGN_SOURCES =
      "FETCHING_ENGAGEMENT_TOP_CAMPAIGN_SOURCES";
export const FETCHING_ENGAGEMENT_TOP_CAMPAIGN_SOURCES_SUCCEDDED =
      "FETCHING_ENGAGEMENT_TOP_CAMPAIGN_SOURCES_SUCCEDDED";
export const FETCHING_ENGAGEMENT_TOP_CAMPAIGN_SOURCES_FAILED =
      "FETCHING_ENGAGEMENT_TOP_CAMPAIGN_SOURCES_FAILED";

export const FETCHING_ENGAGEMENT_COLLECTION_ACTIVITIES =
      "FETCHING_ENGAGEMENT_COLLECTION_ACTIVITIES";
export const FETCHING_ENGAGEMENT_COLLECTION_ACTIVITIES_SUCCEDDED =
      "FETCHING_ENGAGEMENT_COLLECTION_ACTIVITIES_SUCCEDDED";
export const FETCHING_ENGAGEMENT_COLLECTION_ACTIVITIES_FAILED =
      "FETCHING_ENGAGEMENT_COLLECTION_ACTIVITIES_FAILED";
    
export const FETCHING_ENGAGEMENT_CONVERSATION_ACTIVITIES =
      "FETCHING_ENGAGEMENT_CONVERSATION_ACTIVITIES";
export const FETCHING_ENGAGEMENT_CONVERSATION_ACTIVITIES_SUCCEDDED =
      "FETCHING_ENGAGEMENT_CONVERSATION_ACTIVITIES_SUCCEDDED";
export const FETCHING_ENGAGEMENT_CONVERSATION_ACTIVITIES_FAILED =
      "FETCHING_ENGAGEMENT_CONVERSATION_ACTIVITIES_FAILED";


export const FETCHING_PERFORMANCE_INTERACTIONS_GRAPH_REPORT =
      "FETCHING_PERFORMANCE_INTERACTIONS_GRAPH_REPORT";
export const FETCHING_PERFORMANCE_INTERACTIONS_SUCCEEDED =
      "FETCHING_PERFORMANCE_INTERACTIONS_SUCCEEDED";
export const FETCHING_PERFORMANCE_INTERACTIONS_FAILED =
      "FETCHING_PERFORMANCE_INTERACTIONS_FAILED";
    
export const FETCHING_PERFORMANCE_LEADS_GRAPH_REPORT =
      "FETCHING_PERFORMANCE_LEADS_GRAPH_REPORT";
export const FETCHING_PERFORMANCE_LEADS_SUCCEEDED =
      "FETCHING_PERFORMANCE_LEADS_SUCCEEDED";
export const FETCHING_PERFORMANCE_LEADS_FAILED =
      "FETCHING_PERFORMANCE_LEADS_FAILED";
    
export const FETCHING_PERFORMANCE_DEALS_GRAPH_REPORT =
      "FETCHING_PERFORMANCE_DEALS_GRAPH_REPORT";
export const FETCHING_PERFORMANCE_DEALS_SUCCEEDED =
      "FETCHING_PERFORMANCE_DEALS_SUCCEEDED";
export const FETCHING_PERFORMANCE_DEALS_FAILED =
      "FETCHING_PERFORMANCE_DEALS_FAILED";
    
export const FETCHING_PERFORMANCE_DEAL_VALUE_GRAPH_REPORT =
      "FETCHING_PERFORMANCE_DEAL_VALUE_GRAPH_REPORT";
export const FETCHING_PERFORMANCE_DEAL_VALUE_SUCCEEDED =
      "FETCHING_PERFORMANCE_DEAL_VALUE_SUCCEEDED";
export const FETCHING_PERFORMANCE_DEAL_VALUE_FAILED =
      "FETCHING_PERFORMANCE_DEAL_VALUE_FAILED";
    
export const FETCHING_PERFORMANCE_CLOSED_DEALS_GRAPH_REPORT =
      "FETCHING_PERFORMANCE_CLOSED_DEALS_GRAPH_REPORT";
export const FETCHING_PERFORMANCE_CLOSED_DEALS_SUCCEEDED =
      "FETCHING_PERFORMANCE_CLOSED_DEALS_SUCCEEDED";
export const FETCHING_PERFORMANCE_CLOSED_DEALS_FAILED =
      "FETCHING_PERFORMANCE_CLOSED_DEALS_FAILED";
    
export const FETCHING_PERFORMANCE_CLOSED_DEAL_VALUE_GRAPH_REPORT =
      "FETCHING_PERFORMANCE_CLOSED_DEAL_VALUE_GRAPH_REPORT";
export const FETCHING_PERFORMANCE_CLOSED_DEAL_VALUE_SUCCEEDED =
      "FETCHING_PERFORMANCE_CLOSED_DEAL_VALUE_SUCCEEDED";
export const FETCHING_PERFORMANCE_CLOSED_DEAL_VALUE_FAILED =
      "FETCHING_PERFORMANCE_CLOSED_DEAL_VALUE_FAILED";
    
export const FETCHING_PERFORMANCE_TOP_LEADS_CONTENT =
      "FETCHING_PERFORMANCE_TOP_LEADS_CONTENT";
export const FETCHING_PERFORMANCE_TOP_LEADS_CONTENT_SUCCEDDED =
      "FETCHING_PERFORMANCE_TOP_LEADS_CONTENT_SUCCEDDED";
export const FETCHING_PERFORMANCE_TOP_LEADS_CONTENT_FAILED =
      "FETCHING_PERFORMANCE_TOP_LEADS_CONTENT_FAILED";
    
export const FETCHING_PERFORMANCE_TOP_CONTENT_CLOSED_DEALS =
      "FETCHING_PERFORMANCE_TOP_CONTENT_CLOSED_DEALS";
export const FETCHING_PERFORMANCE_TOP_CONTENT_CLOSED_DEALS_SUCCEDDED =
      "FETCHING_PERFORMANCE_TOP_CONTENT_CLOSED_DEALS_SUCCEDDED";
export const FETCHING_PERFORMANCE_TOP_CONTENT_CLOSED_DEALS_FAILED =
      "FETCHING_PERFORMANCE_TOP_CONTENT_CLOSED_DEALS_FAILED";

export const FETCHING_CLOSED_DEALS_DETAIL_REPORT =
      "FETCHING_CLOSED_DEALS_DETAIL_REPORT";
export const FETCHING_CLOSED_DEALS_DETAIL_REPORT_SUCCEEDED =
      "FETCHING_CLOSED_DEALS_DETAIL_REPORT_SUCCEEDED";
export const FETCHING_CLOSED_DEALS_DETAIL_REPORT_FAILED =
      "FETCHING_CLOSED_DEALS_DETAIL_REPORT_FAILED";
    
export const FETCHING_DEALS_REQUEST_DETAIL_REPORT = "FETCHING_DEALS_REQUEST_DETAIL_REPORT";
export const FETCHING_DEALS_REQUEST_DETAIL_REPORT_SUCCEEDED =
      "FETCHING_DEALS_REQUEST_DETAIL_REPORT_SUCCEEDED";
export const FETCHING_DEALS_REQUEST_DETAIL_REPORT_FAILED =
      "FETCHING_DEALS_REQUEST_DETAIL_REPORT_FAILED";
    
export const FETCHING_LEADS_DETAIL_REPORT = "FETCHING_LEADS_DETAIL_REPORT";
export const FETCHING_LEADS_DETAIL_REPORT_SUCCEEDED =
      "FETCHING_LEADS_DETAIL_REPORT_SUCCEEDED";
export const FETCHING_LEADS_DETAIL_REPORT_FAILED =
      "FETCHING_LEADS_DETAIL_REPORT_FAILED";
  
export const INTIALIZING_DOWNLOAD_REPORT_REQUEST =
      "INTIALIZING_DOWNLOAD_REPORT_REQUEST";
export const INTIALIZING_DOWNLOAD_REPORT_SUCCEDDED =
      "INTIALIZING_DOWNLOAD_REPORT_SUCCEDDED";
export const INTIALIZING_DOWNLOAD_REPORT_FAILED =
      "INTIALIZING_DOWNLOAD_REPORT_FAILED";

// Advocacy Reports
export const FETCH_ADVOCACY_TIME_SPENT = "FETCH_ADVOCACY_TIME_SPENT";
export const FETCHING_ADVOCACY_TIME_SPENT_SUCCEEDED =
  "FETCHING_ADVOCACY_TIME_SPENT_SUCCEEDED";
export const FETCHING_ADVOCACY_TIME_SPENT_FAILED =
  "FETCHING_ADVOCACY_TIME_SPENT_FAILED";

export const FETCH_ADVOCACY_VIEWS = "FETCH_ADVOCACY_VIEWS";
export const FETCHING_ADVOCACY_VIEWS_SUCCEEDED =
  "FETCHING_ADVOCACY_VIEWS_SUCCEEDED";
export const FETCHING_ADVOCACY_VIEWS_FAILED = "FETCHING_ADVOCACY_VIEWS_FAILED";

export const FETCH_ADVOCACY_SHARES = "FETCH_ADVOCACY_SHARES";
export const FETCHING_ADVOCACY_SHARES_SUCCEEDED =
  "FETCHING_ADVOCACY_SHARES_SUCCEEDED";
export const FETCHING_ADVOCACY_SHARES_FAILED =
  "FETCHING_ADVOCACY_SHARES_FAILED";

export const FETCH_ADVOCACY_TOP_SHARED_ASSETS =
  "FETCH_ADVOCACY_TOP_SHARED_ASSETS";
export const FETCHING_ADVOCACY_TOP_SHARED_ASSETS_SUCCEEDED =
  "FETCHING_ADVOCACY_TOP_SHARED_ASSETS_SUCCEEDED";
export const FETCHING_ADVOCACY_TOP_SHARED_ASSETS_FAILED =
  "FETCHING_ADVOCACY_TOP_SHARED_ASSETS_FAILED";

  export const FETCH_ADVOCACY_TOP_ENGAGED_ASSETS =
  "FETCH_ADVOCACY_TOP_ENGAGED_ASSETS";
export const FETCHING_ADVOCACY_TOP_ENGAGED_ASSETS_SUCCEEDED =
  "FETCHING_ADVOCACY_TOP_ENGAGED_ASSETS_SUCCEEDED";
export const FETCHING_ADVOCACY_TOP_ENGAGED_ASSETS_FAILED =
  "FETCHING_ADVOCACY_TOP_ENGAGED_ASSETS_FAILED";

export const FETCH_ADVOCACY_TOP_SHARERS = "FETCH_ADVOCACY_TOP_SHARERS";
export const FETCHING_ADVOCACY_TOP_SHARERS_SUCCEEEDED =
  "FETCHING_ADVOCACY_TOP_SHARERS_SUCCEEEDED";
export const FETCHING_ADVOCACY_TOP_SHARERS_FAILED =
  "FETCHING_ADVOCACY_TOP_SHARERS_FAILED";

  export const FETCH_ADVOCACY_TOP_USER_GROUPS =
  "FETCH_ADVOCACY_TOP_USER_GROUPS";
export const FETCHING_ADVOCACY_TOP_USER_GROUPS_SUCCEEDED =
  "FETCHING_ADVOCACY_TOP_USER_GROUPS_SUCCEEDED";
export const FETCHING_ADVOCACY_TOP_USER_GROUPS_FAILED =
  "FETCHING_ADVOCACY_TOP_USER_GROUPS_FAILED";

//Search Users
export const SEARCH_USERS_REQUEST = "SEARCH_USERS_REQUEST";
export const SEARCH_USERS_SUCCEDDED = "SEARCH_USERS_SUCCEDDED";
export const SEARCH_USERS_FAILED = "SEARCH_USERS_FAILED";
export const INVALIDATE_USERS_SEARCH_RESULTS = "INVALIDATE_USERS_SEARCH_RESULTS";

//Search User Groups
export const SEARCHING_USER_GROUPS_REQUEST = "SEARCHING_USER_GROUPS_REQUEST";
export const SEARCHING_USER_GROUPS_SUCCEDDED =
  "SEARCHING_USER_GROUPS_SUCCEDDED";
export const SEARCHING_USER_GROUPS_FAILED = "SEARCHING_USER_GROUPS_FAILED";
export const INVALIDATE_AUTOCOMPLETE_USER_GROUP =
  "INVALIDATE_AUTOCOMPLETE_USER_GROUP";

//Search Contacts
export const SEARCHING_CONTACT = "SEARCHING_CONTACT";
export const SEARCHING_CONTACT_SUCCEDDED = "SEARCHING_CONTACT_SUCCEDDED";
export const SEARCHING_CONTACT_FAILED = "SEARCHING_CONTACT_FAILED";
export const INVALIDATE_CONTACT_SEARCH_RESULT =
  "INVALIDATE_CONTACT_SEARCH_RESULT";

//Search Companies
export const SEARCHING_COMPANIES = "SEARCHING_COMPANIES";
export const SEARCHING_COMPANIES_SUCCEDDED = "SEARCHING_COMPANIES_SUCCEDDED";
export const SEARCHING_COMPANIES_FAILED = "SEARCHING_COMPANIES_FAILED";
export const INVALIDATE_COMPANIES_SEARCH_RESULT = "INVALIDATE_COMPANIES_SEARCH_RESULT";

export const INVALIDATE_REPORTS_DOWNLOAD_DATA = "INVALIDATE_REPORTS_DOWNLOAD_DATA";

//Search User Roles
export const SEARCH_USER_ROLES_FOR_AUTO_COMPLETE = "SEARCH_USER_ROLES_FOR_AUTO_COMPLETE";
export const SEARCH_USER_ROLES_FOR_AUTO_COMPLETE_SUCCEEDED = "SEARCH_USER_ROLES_FOR_AUTO_COMPLETE_SUCCEEDED";
export const SEARCH_USER_ROLES_FOR_AUTO_COMPLETE_FAILED = "SEARCH_USER_ROLES_FOR_AUTO_COMPLETE_FAILED";


// video viewer
export const CAPTURED_ASSET_VIDEO_NEW_RANGE = "CAPTURED_ASSET_VIDEO_NEW_RANGE";
export const UPDATED_ASSET_VIDEO_RANGE = "UPDATED_ASSET_VIDEO_RANGE";
export const REMOVED_ASSET_VIDEO_RANGE = "REMOVED_ASSET_VIDEO_RANGE";
export const SYNCING_ASSET_VIEW_RANGE_REQUEST = "SYNCING_ASSET_VIEW_RANGE_REQUEST";
export const SYNCING_ASSET_VIEW_RANGE_SUCCEDDED = "SYNCING_ASSET_VIEW_RANGE_SUCCEDDED";
export const SYNCING_ASSET_VIEW_RANGE_FAILED = "SYNCING_ASSET_VIEW_RANGE_FAILED";

// Cloning deal Room 
export const CLONE_DEAL_ROOM = "CLONE_DEAL_ROOM";
export const CLONING_DEAL_ROOM_SUCCEEDED = "CLONING_DEAL_ROOM_SUCCEEDED";
export const CLONING_DEAL_ROOM_FALIED = "CLONING_DEAL_ROOM_FALIED";

// deal room reports 

export const FETCHING_DISCOVERY_DEAL_ROOMS_REPORT =
  "FETCHING_DISCOVERY_DEAL_ROOMS_REPORT";
export const FETCHING_DISCOVERY_DEAL_ROOMS_REPORT_SUCCEEDED =
  "FETCHING_DISCOVERY_DEAL_ROOMS_REPORT_SUCCEEDED";
export const FETCHING_DISCOVERY_DEAL_ROOMS_REPORT_FAILED =
  "FETCHING_DISCOVERY_DEAL_ROOMS_REPORT_FAILED";

export const FETCHING_DISCOVERY_DEAL_ROOMS_SHARED_REPORT =
  "FETCHING_DISCOVERY_DEAL_ROOMS_SHARED_REPORT";
export const FETCHING_DISCOVERY_DEAL_ROOMS_SHARED_REPORT_SUCCEDDED =
  "FETCHING_DISCOVERY_DEAL_ROOMS_SHARED_REPORT_SUCCEDDED";
export const FETCHING_DISCOVERY_DEAL_ROOMS_SHARED_REPORT_FAILED =
  "FETCHING_DISCOVERY_DEAL_ROOMS_SHARED_REPORT_FAILED";

export const FETCHING_ENGAGEMENT_DEAL_ROOMS_ACTIVITIES =
  "FETCHING_ENGAGEMENT_DEAL_ROOMS_ACTIVITIES";
export const FETCHING_ENGAGEMENT_DEAL_ROOMS_ACTIVITIES_SUCCEDDED =
  "FETCHING_ENGAGEMENT_DEAL_ROOMS_ACTIVITIES_SUCCEDDED";
export const FETCHING_ENGAGEMENT_DEAL_ROOMS_ACTIVITIES_FAILED =
  "FETCHING_ENGAGEMENT_DEAL_ROOMS_ACTIVITIES_FAILED";

// Settings Adoption Events 
export const TRACK_CUSTOM_FIELD_CLICKED_EVENT = "Add Custom Field Clicked";
export const TRACK_CUSTOM_FIELD_CREATED_EVENT = "Custom Field Created";


export const FETCH_CONTACT_BY_ID = "FETCH_CONTACT_BY_ID";
export const FETCH_CONTACT_BY_ID_SUCCEDDED = "FETCH_CONTACT_BY_ID_SUCCEDDED";
export const FETCH_CONTACT_BY_ID_FAILED = "FETCH_CONTACT_BY_ID_FAILED";

export const FETCH_HUBSPOT_RECOMMENDED_ASSETS = "FETCH_HUBSPOT_RECOMMENDED_ASSETS";
export const FETCHING_HUBSPOT_RECOMMENDED_ASSETS_SUCCEDDED = "FETCHING_HUBSPOT_RECOMMENDED_ASSETS_SUCCEDDED";
export const FETCHING_HUBSPOT_RECOMMENDED_ASSETS_FAILED = "FETCHING_HUBSPOT_RECOMMENDED_ASSETS_FAILED";

export const FETCH_HUBSPOT_SHARES_FOR_OPPORTUNITY = "FETCH_HUBSPOT_SHARES_FOR_OPPORTUNITY";
export const FETCHING_HUBSPOT_SHARES_FOR_OPPORTUNITY_SUCCEDDED = "FETCHING_HUBSPOT_SHARES_FOR_OPPORTUNITY_SUCCEDDED";
export const FETCHING_HUBSPOT_SHARES_FOR_OPPORTUNITY_FAILED = "FETCHING_HUBSPOT_SHARES_FOR_OPPORTUNITY_FAILED";

export const INVALIDATE_HUBSPOT_RECOMMENDED_ASSETS = "INVALIDATE_HUBSPOT_RECOMMENDED_ASSETS";
export const INVALIDATE_HUBSPOT_SHARES_FOR_OPPORTUNITY = "INVALIDATE_HUBSPOT_SHARES_FOR_OPPORTUNITY";
export const INVALIDATE_HUBSPOT_CONTACT = "INVALIDATE_HUBSPOT_CONTACT";